import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const vacancyPostingPage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {
            height: "42.51vw"    
        },
        rightWrapper: {
            paddingBottom: "4vw"
        },
        innerRightWrapper:{ },
        topic: {
            fontSize: "6.03vw",
            fontWeight: "bold" as "bold",
            display: "block",
            color: Color.LightBlack
        },
        buttonWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            alignItems: "center",
            justifyContent: "center",
        },
        backButton: {
            width: "6.76vw",
            height: "6.76vw",
            borderRadius: "50%",
            backgroundColor: Color.LightAsh,
            borderColor: Color.White,
            border: "0.3vw solid white",
            cursor: "pointer",
            fill: Color.SharpAsh                  
        },
        buttonIcon: {
            width: "2.89vw",
            height: "2.89vw",
            marginTop:"0.20vw",
            marginRight:"0.20vw",
            fill: Color.DeepBlack  
        },
        buttonTittle: {
            fontSize: "3.86vw",
            marginLeft: "2.65vw"
        },
        profileWrapper: {
            display: "none"
        },
        pageHeader: {
            display: "flex",
            flexDirection: "row" as "row",
            marginLeft: "6.28vw",
            marginTop: " 6.28vw",
            marginBottom: "2.50vw"
        },
        basicDetails: {
            subTopic: {
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                marginTop: "7.97vw",
                marginLeft: "7.24vw",
                color: Color.DeepBlack
            },
            inputWrapper: {
                marginTop: "4.83vw",
                width: "100%",
                fontFamily: Font.Poppins,
                fontWeight: "500"
            },
            dateWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "4.83vw",
                width: "100%",
                fontFamily: Font.Poppins,
                fontWeight: "500"
            },
            textInput: {
                marginTop: "1.20vw",
                fontSize: "3.86vw"
            },
            label: {
                fontSize: "3.86vw",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                marginLeft: "3.00vw",
                marginBottom: "1.20vw"
            },
            groupWrapper: {
                marginTop: "1.30vw",
                width: "90.33vw",
                fontFamily: Font.Poppins,
                fontWeight: "500"
            },
            searchInput: {
                border: "none",
                backgroundColor: Color.LightAsh,
                valid: {
                    backgroundColor: Color.LightBlue
                },
                invalid: {
                    backgroundColor: "transparent"
                }
            },
            dateInput: {
                marginTop: "0.30vw",
                height: "12.07vw",
                width: "90.33vw",
                border: "none",
                fontSize: "3.86vw",
                borderRadius: "1.20vw",
                backgroundColor: Color.LightAsh,
                fontFamily: Font.Poppins,
                fontWeight: "500",
                color: Color.SharpAsh,
                paddingLeft: "3.62vw",
                paddingRight: "6.56vw",
                cursor: "pointer",
                pointerEvents: "auto",
                boxSizing: "border-box" as "border-box"
            },
            line1: {
                border: "0.24vw solid" + Color.Gainsboro,
                marginTop: "7.24vw",
                marginBottom: "7.24vw"
            },
            line2: {
                border: "0.24vw solid" + Color.Gainsboro,
                marginTop: "7.24vw",
                marginBottom: "9.66vw"
            },
            inputWithLogo: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontFamily: Font.Poppins,
                color: Color.SharpAsh,
                fontSize: "3.86vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw",
                marginBottom: "4.34vw"
            },
            input: {
                border: "none",
                backgroundColor: Color.LightAsh,
                WebkitAppearance: "none",
                MozAppearance: "textfield",
                appearance: "none"
            },
            textAreaInputWrapper: {
                marginTop: "4.83vw"
            },
            textAreaInput:{
                marginTop: "1.20vw",
                textArea: {
                    width: "100%",
                    minHeight: "6.61vw",
                    borderRadius: "1.20vw"
                }
            },
            benifitContainer: {
                display: "flex",
                width: "100%",
                minHeight: "12.07vw",
                flexWrap: "wrap", 
                paddingTop: "2.41vw",
                paddingLeft: "2.41vw",
                paddingRight: "2.41vw", 
                paddingBottom: "2.41vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                cursor: "pointer",
                gap: "1vw",
                alignContent: "flex-start",
                boxSizing: "border-box" as "border-box",
                overflow: "hidden",
                hover: {
                    border: "0.24vw solid" + Color.Black,
                }
            },
            selectorWrapper: {
                position: "relative",
                maxWidth: "calc(100% - 4.82vw)",
                width: "fit-content",
                minHeight: "3.91vh",
                height: "auto",
                paddingLeft: "4.83vw",
                paddingRight: "6vw", 
                paddingTop: "0.5vh",
                paddingBottom: "0.5vh",
                textAlign: "center",
                lineHeight: "1.5",
                borderRadius: "6.04vw",
                backgroundColor: Color.Blue,
                color: Color.LightBlue,
                fontSize: "3.62vw",
                overflow: "visible",
                wordBreak: "break-word",
                whiteSpace: "normal",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "0 0 auto",
                WebkitTapHighlightColor: "transparent",
                userSelect: "none",
                boxSizing: "border-box" as "border-box"
            },
            searchContainer: {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                width: "100%",
                minHeight: "12.07vw",
                paddingTop: "2.41vw",
                paddingLeft: "2.41vw",
                paddingBottom: "1.41vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                cursor: "pointer",
                gap: "1vw",
                boxSizing: "border-box" as "border-box",
                hover: {
                    border: "0.24vw solid" + Color.Black,
                }
            },
            customerWrapper: {
                display: "flex", 
                flexDirection: "row" as "row",   
                alignItems: "center",                                                                              
                width: "90.33vw",
                height: "9.36vw",
                border: "0.24vw solid" + Color.LightGray,
                borderRadius: "1.69vw",
                marginTop: "1.69vw",
                paddingLeft: "3.50vw",
                boxSizing: "border-box" as "border-box"
            },
            customBenifit: {
                width: "90%",
                border: "none",
                color: Color.SharpAsh,
            },
            addButton: {
                boreder: "1px solid red",
                width: "2.5vw",
                height: "2.5vw",
                marginLeft: "2vw"
            },
            benifitHoverWrapper: {
                position: "absolute",
                width: "90.33vw",
                backgroundColor: Color.White,
                boxSizing: "border-box" as "border-box",
                paddingBottom: "3.04vw",
                paddingTop: "2.04vw",
                paddingLeft: "3.62vw",
                paddingRight: "3.62vw",  
                borderRadius: "0 0 0.52vw 0.52vw",
                zIndex: "1",
                height: "auto" ,
                border: "0.24vw solid" + Color.LightSilver,
                fontSize: "3.86vw"
            },
            levelHoverWrapper: {
                position: "absolute",
                width: "90.33vw",
                border: "0.05vw solid" + Color.LightSilver,
                backgroundColor: Color.White,
                paddingBottom: "3.04vw",
                paddingLeft: "3.62vw",
                paddingRight: "3.62vw",  
                borderRadius: "0 0 1.69vw 1.69vw",
                height: "auto",
                maxHeight: "46.30vw",   
                zIndex: "1",
                boxSizing: "border-box" as "border-box" 
            },
            levelScrollArea: {
                maxHeight: "40.30vw",
                overflowY: "auto"
            },
            levelDropDownItem: {
                color: Color.MiddleBlack,
                fontWeight: "500",
                paddingTop: "1.56vw",
                paddingLeft: "1.56vw",
                height: "7vw",
                hover: {
                    backgroundColor: Color.LightAsh,
                    borderRadius: "1.94vw",
                    cursor: "pointer"
                }
            },
            benifitbottomBorder: {
                width: "100%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1",
                hover: {
                    background: Color.MiddleAsh
                }
            },
            levelBottomBorder: {
                width: "95%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1",
                hover: {
                    background: Color.MiddleAsh
                }
            },
            dropdownItem: {
                fontSize: "3.86vw", 
                fontWeight: "500",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,     
                cursor: "pointer",
                paddingLeft: "1.52vw",    
                hover: {
                    backgroundColor: Color.LightAsh,
                    borderRadius: "0.36vw"   
                }
            },
            coverLetterEditor: {
                minHeight: "60.38vw",
                width: "100%",
                border: "0.05vw solid" + Color.MiddleAsh,
                marginTop: "0.62vw",
                borderRadius: "1.20vw",
                iconWrapper: {
                    borderRadius: "1.20vw 1.20vw 0vw 0vw"
                }
            },
            instruction: {
                fontSize: "2.65vw",
                color: Color.SharpAsh,
                marginTop: "1.20vw",
                marginLeft: "2.41vw"
            },
            imageText: {
                fontSize: "2.65vw",
                color: Color.Blue,
                marginTop: "2.52vw",
                marginLeft: "2.00vw",
                cursor: "pointer"
            },
            textMedium: {
                ontSize: "2.65vw",
                color: Color.SharpAsh,
                fontWeight: "800",
            },
            form: {
                paddingLeft: "4.83vw",
                paddingRight: "4.83vw"
            },
            cvLimit: {
                marginTop: "1.69vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontWeight: "bold" as "bold",
            },
            buttonsWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontSize: "3.86vw",
                back:{
                    color: Color.SharpAsh,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontWeight: "bold" as "bold",
                    fontSize: "3.86vw"
                },
                next: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "2.41vw"      
                },
                save: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginTop: "-5.52vw",
                    marginLeft: "51.50vw"      
                }
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: Font.Poppins,
                fontWeight: "500",
                color: Color.DeepAsh,
                fontSize: "3.86vw",
                border: "none",
                padding: "2.89vw 1.5vw 2.41vw 3.62vw",
                borderRadius: "0.52vw"
            },
            cvBaseWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: Font.Poppins,
                fontWeight: "500",
                color: Color.DeepAsh,
                fontSize: "3.86vw",
                border: "none",
                padding: "2.89vw 1.5vw 2.41vw 3.62vw",
                borderRadius: "0.52vw",
                monthly: {
                    width: "95%"
                }
            },
            groupIcon: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "32.12vw"
            },
            icon: {
                width: "4.10vw",
                height: "4.588vw",
                color: Color.Black
            },
            dropdown: {
                wrapper: {
                    position: "relative" as "relative",
                    display: "inline-block"
                },
                button: {
                    backgroundColor: "transparent",
                    color: Color.LightAsh,
                    fontSize: "0.937vw",
                    fontWeight: "bold" as "bold",
                    border: "none",
                    cursor: "pointer"
                },
                item: {
                    textAlign: "left"
                },
                labelWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row"
                },
                labelIcon: {
                    width: "0.8vw",
                    fill: Color.LightAsh,
                    marginLeft: "0.3vw",
                    marginTop: "0.8vh",
                    transition: "all 0.1s linear",
                    hover: {
                        transform: "rotate(180deg)"
                    }
                },
                label: {
                    textDecoration: "none",
                    fontSize: "0.8vw",
                    letterSpacing: "0px",
                    color: Color.LightAsh,
                    opacity: "1"
                },
                leave: {
                    display: "none"
                },
                hover: {
                    display: "block",
                    position: "absolute" as "absolute",
                    width: "8.64vw",
                    height: "auto",
                    padding: "0.52vw",
                    left: "50%",
                    transform: "translate(-50%)",
                    backgroundColor: Color.White,
                    boxShadow: "5px 5px 45px #00000029",
                    borderRadius: "0.52vw",
                    zIndex: 3
                },
                bottomBorder: {
                    border: 0,
                    height: "1px",
                    width: "95%",
                    background: Color.MiddleAsh,
                    margin: "0 auto",
                    zIndex: "1"
                },
                hoveredBorder: {
                    background: Color.White,
                    borderRadius: "1px"
                }
            },
            tabSwitch: {
                switch: {
                    backgroundColor: Color.LightGray,
                    borderRadius: "69.44vw",
                    cursor: "pointer",
                    display: "flex",
                    height: "5vw",
                    width: "11.11vw",
                    padding: "0.56vw",
                    margin: "auto",
                    marginRight: "unset",
                    WebkitTapHighlightColor: "transparent",
                    checked: {
                        backgroundColor: Color.SharpGreen
                    }
                },
                switchCircle: {
                    height: "5vw",
                    width: "5vw",
                    borderRadius: "50%",
                    backgroundColor: Color.White,
                    checked: {
                        marginLeft: "auto",
                        backgroundColor: Color.Green
                    }
                }
            },
            allSectorWrapper: {
                border: "1px dashed " + Color.DarkGray,
                color: Color.SharpAsh,
                backgroundColor: "unset"
            },
            leave: {
                display: "none"
            },
            hover: {
                display: "block",
                position: "absolute",
                width: "70vw",
                height: "33.59vh",
                bottom: "-34.59vh",
                left: "-0.5vw",
                backgroundColor: Color.White,
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.42vw",
                zIndex: 1
            },
            search: {
                display: "flex",
                height: "4.05vh",
                width: "90%",
                margin: "auto",
                marginTop: "1.35vh",
                fontSize: "3.38vw",
                paddingLeft: "1.35vh",
                color: Color.Black,
                border: "none",
                borderRadius: "4.16vw",
                backgroundColor: Color.LightAsh,
                icon: {
                    position: "absolute" as "absolute",
                    width: "3.4vw",
                    height: "3.4vw",
                    fill: Color.SharpAsh,                
                    top: "8%",
                    left: "19.12vw"
                }
            },
            hoverWrapper: {
                position: "absolute",
                paddingTop: "0.78vw",
                left: "5%",
                zIndex: "1"
            },
            scrollArea: {
                height: "80%",
                overflow: "auto",
                marginTop: "1.38vw"
            },
            closeIcon: {
                position: "absolute",
                right: "1vw", 
                top: "10%",
                transform: "translateY(-50%)", 
                cursor: "pointer",
                zIndex: 10,
                height: "2.23vh",
                width: "4.83vw",
            },
            redCloseIcon: {
                position: "absolute",
                height: "2.23vh",
                width: "4.83vw",
                marginLeft: "1.45vw",
            },
            option: {
                margin: "0 2.19vw",
                padding: "0.312vw 2.19vw",
                textAlign: "left",
                color: Color.MiddleBlack,
                fontSize: "3.86vw",
                fontWeight: "medium",
                cursor: "pointer",
                zIndex: 1,
                WebkitTapHighlightColor: "transparent",
                userSelect: "none",
                hover: {
                    backgroundColor: Color.LightBlue,
                    borderRadius: "1.93vw"
                },
                leave: {
                    backgroundColor: Color.White
                }
            },
            sectorContainer: {
                display: "block",
                flexDirection: "unset",
                border: "1px solid " + Color.LightSilver,
                borderRadius: "1.21vw",
                padding: "3.62vw",
                position: "relative"
            },
            bottomBorder: {
                border: 0,
                height: "1px",
                width: "92%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1"
            },
            valid: {
                backgroundColor: Color.LightBlue,
                border: "1px solid " + Color.Blue
            },
            invalid: {
                backgroundColor: Color.CoralRed,
                border: "1px solid " + Color.Red,
                color: Color.Red
            },
            attachment: {
                marginTop: "1.20vw",
                cursor: "pointer",
                padding: "1.50vw",
                selectedFileName: {
                    fontFamily: Font.Poppins,
                    fontSize: "3.86vw",
                    color: Color.SharpAsh,
                    margin: "1.19vw 0 1.14vw 1.56vw"
                },
                fileIcon: {
                    marginRight: "1.51vw"
                }
            },
            uploadedImage: {
                width: "100%",
                height: "100%"
            },
            uploadImagePopup: {
                container: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    maxHeight: "50%",
                    height: "auto"
                }
            }
        },
        vacancyQuestion: {
            mainWrapper: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            subTopicWrapper: {
                topic: {
                    fontSize: "4.34vw",
                    fontWeight: "bold" as "bold",
                    marginTop: "8.45vw",
                    marginLeft: "7.24vw",
                    color: Color.LightBlack
                }
            },
            passScore: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                boxSizing: "border-box" as "border-box",
                width: "90.33vw",
                height: "21.73vw",
                border: "0.72vw solid" + Color.Green,
                borderRadius: "2.41vw",
                marginTop: "4.34vw",
                backgroundColor: Color.Nyanza,
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                fontWeight: "500",
                fontSize: "3.86vw",
                paddingLeft: "4.83vw"
            },
            passScoreInput: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                width: "43.23vw",
                height: "12.07vw",
                backgroundColor: Color.White,
                borderRadius: "0.52vw",
                marginLeft: "8.00vw",
                paddingLeft: "3.62vw",
                paddingRight: "3.62vw",
                boxSizing: "border-box" as "border-box",
                input: {
                    border: "none",
                    width: "32.88vw",
                    backgroundColor: Color.White,
                    invalid: {
                        backgroundColor: "transparent",
                        color: Color.Red
                    }
                },
                invalid: {
                    backgroundColor: Color.CoralRed,
                    border: "1px solid " + Color.Red,
                    color: Color.Red
                }
            },
            passScoreText: {
                display: "flex",
                flexDirection: "column" as "column",
                fontFamily: Font.Poppins,
                fontSize: "3.56vw",
                width: "30.15vw"
            },
            passScoreInvlidText: {
                fontSize: "3.16vw",
                color: Color.Red
            },
            notifyMailWrapper: {
                fontSize: "3.00vw",
                paddingLeft: "3.62vw",
                marginTop: "2.00vw"
            },
            inputError: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                fontSize: "4.44vw",
                textAlign: "center",
                icon: {
                    width: "4.17vw",
                    height: "4.17vw",
                    overflow: "unset"
                }
            },
            form: {
                paddingLeft: "4.83vw",
                paddingRight: "4.83vw"
            },
            groupIcon: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                icon: {
                    width: "4.10vw",
                    height: "4.58vw",
                    cursor: "pointer"
                },
                arrow: {
                    width: "4.10vw",
                    height: "4.58vw"
                }
            },
            addNewQuestionWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "4.34vw",
                boxSizing: "border-box" as "border-box", 
                fontFamily: Font.Poppins,
                fontWeight: "bold" as "bold",
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                width: "90.33vw"  
            },
            frequenltyQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "2.65vw",
                color: Color.White,
                width: "43.06vw",
                height: "8.45vw" ,
                backgroundColor: Color.RoseRed,
                borderRadius: "1.69vw",
                marginRight: "1.25vw"
            },
            addNewQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "2.65vw",
                color: Color.White,
                width: "45.06vw",
                height: "8.45vw",
                backgroundColor: Color.DeepBlack,
                borderRadius: "1.69vw"
            },
            singleAddNewQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
                color: Color.White,
                width: "63.04vw",
                height: "12.07vw",
                backgroundColor: Color.DeepBlack,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw  #00000027"
            },
            selectedQuetionsDeleteButton: {
                color: Color.Red,
                backgroundColor: Color.White,
                fontSize: "3.38vw",
                fontWeight: "bold" as "bold",
                 width: "63.04vw",
                height: "12.07vw",
                borderRadius: "1.69vw",
                border: "0.48vw solid" + Color.Linen,
                marginBottom: "3.62vw"
            },
            plusIcon: {
                fill: Color.White,
                width: "2.55vw",
                height: "2.55vw",
                marginLeft: "2.41vw"
            },
            addNewquestion: {
                width: "90.33vw",
                border: "0.48vw solid" + Color.Gainsboro,
                marginTop: "9.66vw",
                boxSizing: "border-box" as "border-box",
                padding: "4.83vw 2.41vw 4.83vw 2.41vw",
                borderRadius: "2.41vw"
            },
            labelWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "1vw"
            },
            qusetionTittle: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw"
            },
            checkBoxGroup: {
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center"
            },
            inputWrapper: {
                marginTop: "4.00vw",
                width: "100%"
            },
            label: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                marginLeft: "3.42vw"
            },
            textInput: {
                marginTop: "1.20vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh
            },
            answerWrapper: {
                marginTop: "4.83vw"
            },
            singleButton: {
                marginTop: "6.03vw",
                marginLeft: "13.76vw"
            },
            selector: {
                mainWrapper: {
                    width: "85.50vw",
                    marginTop: "4.83vw"
                },
                label: {
                    fontWeight: "Regular" as "Regular"
                },
                inputWrapper: {
                    backgroundColor: Color.White,
                    border: "0.10vw solid" + Color.SharpAsh,
                    height: "12.07vw"
                },
                answer: {
                    mainWrapper: {
                        width: "85.50vw",
                        marginTop: "1.04vw"
                    },
                    inputWrapper: {
                        marginTop: "2.0vw",
                        backgroundColor: Color.White,
                        border: "0.10vw solid" + Color.SharpAsh
                    },
                    label: {
                        fontWeight: "Regular" as "Regular"
                    },
                    dropdownWrapper: {
                        height: "10.80vw"
                    }
                }
            },
            yesNoType: { },
            openQuestionText: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "500",
                color: Color.HarvestGold,
                marginLeft: "3.14vw",
                marginTop: "2.41vw"
            },
            addYesNoAnswer: { },
            addMultipleChoiceAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between"
            },
            addKnoctoutAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between"
            },
            knoctoutAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "500",
                backgroundColor: Color.LightAsh,
                border: "none",
                width: "45.20vw",
                height: "8.21vw",
                borderRight: "0.48vw solid" + Color.Gainsboro,
                invalid: {
                    backgroundColor: "transparent",
                    color: Color.Red
                }               
            },
            addsingleChoiceAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between"
            },
            multipleAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "1.20vw",
                width: "85.50vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                boxSizing: "border-box" as "border-box",
                borderRadius: "0.52vw",
                paddingLeft: "3.62vw",
                invalid: {
                    backgroundColor: Color.CoralRed,
                    border: "1px solid " + Color.Red,
                    color: Color.Red
                }
            },
            multipleAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "300",
                backgroundColor: Color.LightAsh,
                border: "none",
                width: "51.20vw",
                height: "8.21vw",
                borderRight: "0.48vw solid" + Color.Gainsboro,
                invalid: {
                    backgroundColor: "transparent",
                    color: Color.Red
                }           
            },
            multipleScore: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "300",
                width: "19.80vw",
                backgroundColor: Color.LightAsh,
                border: "none",
                marginLeft: "3.62vw",
                invalid: {
                    backgroundColor: "transparent",
                    color: Color.Red
                }
            },
            multiplChoiceAddButton: {
                width: "36.71vw",
                height: "8.45vw",
                fontSize: "3.38vw",
                color: Color.Green,
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Nyanza,
                borderRadius: "1.69vw",
                marginLeft: "48.79vw",
                marginTop: "2.41vw",
                marginBottom: "4.83vw"
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.38vw",
                fontWeight: "bold" as "bold",
                marginTop: "7.24vw",
                group: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    alignItems: "center"
                },
                topRow: {
                    order: 2    
                },
                bottomRow: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "flex-end",
                    order: 1,
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    boxSizing: "border-box" as "border-box",
                    color: Color.DeepBlack,
                    width: "31.88vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.93vw",
                    fontWeight: "bold" as "bold"
                },
                submit: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    boxSizing: "border-box" as "border-box",
                    width: "50.72vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                update: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "85.50vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                delete: {
                    color: Color.Red,
                    backgroundColor: Color.White,
                    width: "31.88vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    height: "8.45vw",
                    borderRadius: "1.69vw",
                    border: "0.48vw solid" + Color.Linen,
                    marginLeft: "20.00vw",
                    marginBottom: "3.62vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    color: Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            answersLabelWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "4.34vw",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between"
            },
            totalScoreWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "4.34vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "3vw"
            },
            answerAndScoreMainWrapper: {
                width: "100%"
            },
            answerAndScoreWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "2.41vw"                        
            },
            textWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "300",
                color: Color.DeepAsh,
                marginLeft: "6.03vw"                
            },
            deleteIcon: {
                width: "2.67vw",
                height: "2.67vw",
                marginLeft: "1.1vw",
                cursor: "pointer"               
            },
            knockoutAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "1.20vw",
                width: "85.50vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "0.52vw",
                paddingLeft: "1.56vw",
                boxSizing: "border-box" as "border-box",
                invalid: {
                    backgroundColor: Color.CoralRed,
                    border: "1px solid " + Color.Red,
                    color: Color.Red
                }
            },
            KnockoutAddButton: {
                width: "36.71vw",
                height: "8.45vw",
                fontSize: "3.38vw",
                color: Color.Green,
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Nyanza,
                borderRadius: "1.69vw",
                marginLeft: "49.20vw",
                marginTop: "2.41vw"
            },
            radioButton: {
                radioButton: {
                    width: "2.00vw",
                    height: "2.00vw"
                }
            },
            radioButtonsGrop: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center"
            },
            radioButtonGrop: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                width: "16.09vw",
                height: "8.30vw",
                marginLeft: "1.3vw"
            },
            radioButtonText: {
                fontFamily: Font.Poppins,
                fontSize: "3.38vw",
                marginLeft: "2.41vw",
                fontWeight: "500",
                color: Color.SharpAsh,
                clicked: {
                    color: Color.DeepBlack
                } 
            },
            knockoutAnswersWrapper: {
                width: "85.50vw",
                marginTop: "2.41vw"
            },
            knockoutAnswerLabelWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "4.34vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "85.50vw",
                paddingRight: "1.2vw",
                boxSizing: "border-box" as "border-box"
            },
            singleChoiceText: {
                fontFamily: Font.Poppins,
                fontSize: "3.38vw",
                fontWeight: "800",
                color: Color.LightBlack,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "flex-end"                
            },
            singleAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "0.52",
                width: "85.50vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                paddingLeft: "1.56vw",
                boxSizing: "border-box" as "border-box",
                invalid: {
                    backgroundColor: Color.CoralRed,
                    border: "1px solid " + Color.Red,
                    color: Color.Red
                }
            },
            singleAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                width: "50.72vw",
                fontWeight: "500",
                backgroundColor: Color.LightAsh,
                border: "none",
                borderRight: "0.10vw solid" + Color.Gainsboro,
                invalid: {
                    backgroundColor: "transparent",
                    color: Color.Red   
                }
            },
            buttonsWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                marginTop: "9.66vw",
                back:{
                    border: "none",
                    color: Color.SharpAsh,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontWeight: "bold" as "bold",
                    fontSize: "3.86vw"
                },
                save: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginTop: "-5.52vw",
                    marginLeft: "47.50vw"         
                },
                next: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "2.41vw"
                },
                add: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw"
                },
                ok: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "1.20vw",
                    marginLeft: "82.00vw"
                }
            },
            questions: {
                width: "90.33vw",
                border: "0.48vw solid" + Color.Gainsboro,
                marginBottom: "3.62vw",
                boxSizing: "border-box" as "border-box",
                padding: "4.83vw",
                borderRadius: "2.41vw",
                transition: 'all 0.3s ease'
            },
            insideQuestion: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "6.76vw"          
            },
            questionType: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.SharpAsh,
                width: "48.30vw"
            },
            menuIcon: {
                width: "3.58vw",
                height: "3.80vw",
                fill: Color.SharpAsh,
                marginLeft: "4.98vw",
                cursor: "pointer",
                marginTop: "0.83vw"
            },
            iconGroup: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "center",
                alignItems: "baseline"
            },
            checkBoxWrapper: {
                marginTop: "7.24vw",
                marginBottom: "5.00vw",
                marginLeft: "5.20vw"
            },
            checkBoxText: {
                fontSize: "3.86vw"
            },
            questionTextWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                boxSizing: "border-box" as "border-box",
                width: "80.91vw",
                paddingTop: "2.41vw",
                justifyContent: "space-between",
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.Black
            },
            questionAnswerWrapper: {
                borderTop: "0.10vw solid" + Color.Gainsboro,
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginTop: "1.62vw",
                paddingTop: "2.41vw"          
            },
            answers: {
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                minWidth: "7.5vw",
                display: "flex",
                flexDirection: "row" as "row",
                fontSize: "3.86vw",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "2.41vw",
                score: {
                    marginLeft: "4.83vw"
                }    
            },
            line: {
                width: "90.33vw",
                fill: Color.Gainsboro,
                marginTop: "7.24vw"
            },                       
            questionPopup:{
                container: {                    
                    width: "100%",
                    height: "150vw",                    
                    borderRadius: "2.41vw 2.41vw 0vw 0vw",
                    padding: "1.50vw",
                    paddingTop: "4.50vw",
                    boxSizing: "border-box" as "border-box"
                },
                closeButton: {                    
                    width: "3.94vw",
                    height: "3.94vw",
                    top: "1.31vw",
                    right: "1.41vw"
                }
            },
            questionListWrapper: {
                height: "125.00vw",  
                overflowY: "scroll"
            },
            popUpForm: {
                margin: "0.52vw",
                display: "flex",
                flexDirection: "column" as "column",
                height: "auto"
            },
            searchBar: {               
                width: "100%",
                marginTop: "1.7vw",
                marginBottom: "1vw",
                paddingLeft: "1.52vw",
                paddingTop: "0.58vw",
                paddingBottom: "0.58vw",
                borderRadius: "1.69vw",
                fontSize: "2.50vw",
                boxSizing: "border-box" as "border-box"
            },
            popUpQuestionWrapper: {               
                display: "flex",
                flexDirection: "row" as "row",  
                justifyContent: "space-between",
                color: Color.DeepAsh,
                border: "0.052vw solid" + Color.Ash,
                padding: "1.78vw",
                marginBottom: "0.78vw"
            },
            questionAndAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                fontSize: "2.50vw"
            },
            questionTypeAndButton: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between",
                alignItems: "flex-end",
                fontSize: "2.50vw"
            },
            sampleAnswers: {
                marginTop: "0.78vw",
                marginLeft: "0.78vw"
            },
            deleteWarningDialog: {
                container: {
                    width: "calc(100% - 9.66vw)",
                    height: "61.83vw",
                    padding: "7.246vw 4.93vw",
                    borderRadius: "2.415vw 2.415vw 0 0"
                }
            },
            deleteDialogTitle: {
                marginBottom: "7vw",
                fontSize: "7.24vw",
                color: Color.LightBlack
            },
            deleteButton: {
                width: "50%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "4.83vw",
                borderRadius: "2.41vw",
                margin: "7.24vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent"
                },
                red: {
                    marginRight: "2.89vw",
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.LightRed
                }
            }
        },
        cvLessQuestion: {
            subTopicWrapper: {
                topic: {
                    fontSize: "4.34vw",
                    fontWeight: "bold" as "bold",
                    marginTop: "8.45vw",
                    marginLeft: "7.24vw",
                    color: Color.LightBlack
                }
            },            
            inputError: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                fontSize: "4.44vw",
                textAlign: "center",
                icon: {
                    width: "4.17vw",
                    height: "4.17vw",
                    overflow: "unset"
                }
            },
            form: {
                paddingLeft: "4.83vw",
                paddingRight: "4.83vw"
            },
            groupIcon: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                icon: {
                    width: "4.10vw",
                    height: "4.58vw",
                    cursor: "pointer"
                }
            },
            serviceWrapper: { 
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                marginTop: "4.83vw",
                height: "19.32vw",
                border: "0.72vw solid" + Color.MiddleAsh,
                backgroundColor: Color.Cultured,
                boxSizing: "border-box" as "border-box",
                borderRadius: "2.41vw",
                padding: "4.10vw 4.83vw 3.86vw 4.83vw",
                marginBottom: "2.41vw"
            },
            serviceText: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            Topic: {
                fontSize: "3.86vw",
                color: Color.Black,
                fontWeight: "bold"
            },
            subTopic: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontWeight: "regular"
            },
            smsServiceMainWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "4.83vw",
                borderRadius: "2.41vw",
                padding: "4.83vw",
                boxSizing: "border-box" as "border-box",
                border: "0.48vw solid" + Color.Gainsboro
            },
            smsServiceTittle: {
                fontWeight: "bold" as "bold",
                marginLeft: "2.41vw",
                color: Color.Black,
                fontSize: "3.86vw"     
            },
            textAreaWrapper: {
                marginTop: "4.83vw"
            },
            textAreaInput:{
                marginTop: "0.52vw",
                textArea: {
                    width: "100%",
                    height: "24.15vw"
                }
            },
            showTags: {
                marginTop: "0.26vw",
                fontFamily: Font.Poppins,
                fontWeight: "bold" as "bold",
                marginLeft: "57.00vw",
                color: Color.Blue,
                fontSize: "3.86vw",
                cursor: "pointer"
            },
            showTagWrapper: {
                container: {
                    width: "90%",
                    height: "60.38vw",
                    borderRadius: "2.41vw",
                    padding: "6.83vw 4.83vw 4.83vw 4.83vw"
                }
            },
            tagTextAndIconWrapper: {
                marginTop: "6.04vw"
            },
            tagTextAndIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "3.04vw",
                fontFamily: Font.Poppins,
                fontSize: "4.10vw"
            },
            duplicateIcon: {
                width: "4.83vw",
                height: "4.83vw",
                marginLeft: "2.41vw",
                cursor: "pointer"
            },
            dateWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "1.30vw",
                marginBottom: "1vw",
                width: "100%",
                fontFamily: Font.Poppins,
                fontWeight: "500"
            },
            dateInput: {
                marginTop: "1.20vw",
                height: "12.07vw",
                border: "none",
                borderRadius: "1.20vw",
                fontSize: "3.86vw",
                backgroundColor: Color.LightAsh,
                fontFamily: Font.Poppins,
                fontWeight: "500",
                width: "79.90vw",
                color: Color.SharpAsh,
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw",
                boxSizing: "border-box" as "border-box"
            },
            interviewDateAddButton: {
                fontSize: "3.86vw",
                marginTop: "2.00vw",
                color: Color.Green,
                backgroundColor: Color.Nyanza,
                width: "24.15vw",
                height: "8.45vw",
                borderRadius: "1.93vw",
                fontWeight: "bold" as "bold",
                marginLeft: "56.03vw",
                hover: {
                    backgroundColor: Color.Nyanza
                }
            },
            locationAddButton: {
                fontSize: "3.86vw",
                marginTop: "2.00vw",
                color: Color.Green,
                backgroundColor: Color.Nyanza,
                width: "24.15vw",
                height: "8.45vw",
                borderRadius: "1.93vw",
                fontWeight: "bold" as "bold",
                marginLeft: "56.03vw",
                hover: {
                    backgroundColor: Color.Nyanza
                }
            },
            locationInputWrapper: {
                marginTop: "2.41vw"
            },
            locationAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "flex-start", 
                justifyContent: "space-between",
                marginTop: "2.41vw",
                flexWrap: "wrap", 
                whiteSpace: "normal", 
                wordBreak: "break-word", 
                lineHeight: 1.1 
            },
            answerGruop: {
                display: "flex",
                flexDirection: "column" as "column",
                maxWidth: "60vw"
            },
            locationAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "3.38vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                marginRight: "1.04vw",
                marginLeft: "0.52vw",
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5
            },
            smsSave: {
                fontSize: "3.86vw",
                marginTop: "9.66vw",
                color: Color.White,
                backgroundColor: Color.Green,
                width: "63.04vw",
                height: "12.07vw",
                borderRadius: "2.41vw",
                fontWeight: "bold" as "bold",
                marginLeft: "09.76vw",
                hover: {
                    backgroundColor: Color.Green
                } 
            },
            tabSwitch: {
                switch: {
                    backgroundColor: Color.LightGray,
                    borderRadius: "69.44vw",
                    cursor: "pointer",
                    display: "flex",
                    height: "5vw",
                    width: "11.11vw",
                    padding: "0.56vw",
                    margin: "auto",
                    marginRight: "unset",
                    WebkitTapHighlightColor: "transparent",
                    checked: {
                        backgroundColor: Color.SharpGreen
                    }
                },
                switchCircle: {
                    height: "5vw",
                    width: "5vw",
                    borderRadius: "50%",
                    backgroundColor: Color.White,
                    checked: {
                        marginLeft: "auto",
                        backgroundColor: Color.Green
                    }
                }
            },
            addNewQuestionWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "4.34vw",
                boxSizing: "border-box" as "border-box", 
                fontFamily: Font.Poppins,
                fontWeight: "bold" as "bold",
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                width: "90.33vw"  
            },
            frequenltyQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "2.65vw",
                color: Color.White,
                width: "43.06vw",
                height: "8.45vw" ,
                backgroundColor: Color.RoseRed,
                borderRadius: "1.69vw",
                marginRight: "1.25vw",
                hover: {
                    backgroundColor: Color.RoseRed
                }
            },
            addNewQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "2.65vw",
                color: Color.White,
                width: "45.06vw",
                height: "8.45vw",
                backgroundColor: Color.DeepBlack,
                borderRadius: "1.69vw",
                hover: {
                    backgroundColor: Color.DeepBlack
                }
            },
            singleAddNewQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
                color: Color.White,
                width: "63.04vw",
                height: "12.07vw",
                backgroundColor: Color.DeepBlack,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw  #00000027"
            },
            selectedQuetionsDeleteButton: {
                color: Color.Red,
                backgroundColor: Color.White,
                fontSize: "3.38vw",
                fontWeight: "bold" as "bold",
                 width: "63.04vw",
                height: "12.07vw",
                borderRadius: "1.69vw",
                border: "0.48vw solid" + Color.Linen,
                marginBottom: "3.62vw"
            },
            plusIcon: {
                fill: Color.White,
                width: "2.55vw",
                height: "2.55vw",
                marginLeft: "2.41vw"
            },
            addNewquestion: {
                width: "90.33vw",
                border: "0.48vw solid" + Color.Gainsboro,
                marginTop: "9.66vw",
                boxSizing: "border-box" as "border-box",
                padding: "4.83vw 2.41vw 4.83vw 2.41vw",
                borderRadius: "2.41vw"
            },
            labelWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "1vw"
            },
            tittleWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "1vw"
            },
            qusetionTittle: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
            },
            checkBoxGroup: {
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center"
            },
            inputWrapper: {
                marginTop: "4.00vw",
                width: "100%"
            },
            label: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                marginLeft: "3.42vw"
            },
            questionLabel: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "200",
                color: Color.DeepAsh,
                marginLeft: "3.42vw"
            },
            textInput: {
                marginTop: "1.20vw",
                height: "12.07vw",
                fontSize: "3.86vw"
            },
            answerWrapper: {
                marginTop: "4.83vw"
            },
            singleButton: {
                marginTop: "6.03vw",
                marginLeft: "13.76vw"
            },
            selector: {
                mainWrapper: {
                    width: "85.50vw",
                    marginTop: "4.83vw"
                },
                label: {
                    fontWeight: "200"
                },
                inputWrapper: {
                    backgroundColor: Color.White,
                    border: "0.10vw solid" + Color.SharpAsh,
                    height: "12.07vw"
                },
                answer: {
                    mainWrapper: {
                        width: "85.50vw",
                        marginTop: "1.04vw"
                    },
                    inputWrapper: {
                        marginTop: "2.0vw",
                        backgroundColor: Color.White,
                        border: "0.10vw solid" + Color.SharpAsh
                    },
                    label: {
                        fontWeight: "Regular" as "Regular"
                    },
                    dropdownWrapper: {
                        height: "20.80vw"
                    }
                }
            },
            addSingleChoiceAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between"
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.38vw",
                fontWeight: "bold" as "bold",
                marginTop: "7.24vw",
                group: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    alignItems: "center"
                },
                topRow: {
                    order: 2    
                },
                bottomRow: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "flex-end",
                    order: 1,
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    boxSizing: "border-box" as "border-box",
                    color: Color.DeepBlack,
                    width: "31.88vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.93vw",
                    fontWeight: "bold" as "bold"
                },
                submit: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    boxSizing: "border-box" as "border-box",
                    width: "50.72vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                update: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "85.50vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                delete: {
                    color: Color.Red,
                    backgroundColor: Color.White,
                    width: "31.88vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    height: "8.45vw",
                    borderRadius: "1.69vw",
                    border: "0.48vw solid" + Color.Linen,
                    marginLeft: "20.00vw",
                    marginBottom: "3.62vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    color: Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            answersLabelWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "4.34vw",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between"
            },
            answerAndScoreWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                lineHeight: "1.1",
                marginBottom: "2.41vw",
                answer: {
                    maxWidth: "60vw",
                    height: "auto",
                    overflow: "visible", 
                    whiteSpace: "normal", 
                    wordBreak: "break-word"
                }
            },
            textWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                fontWeight: "500",
                color: Color.DeepAsh                   
            },
            deleteIcon: {
                width: "2.67vw",
                height: "2.67vw",
                marginLeft: "1.1vw",
                cursor: "pointer"               
            },
            KnockoutAddButton: {
                width: "36.71vw",
                height: "8.45vw",
                fontSize: "3.38vw",
                color: Color.Green,
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Nyanza,
                borderRadius: "1.69vw",
                marginLeft: "49.20vw",
                marginTop: "2.41vw"
            },
            knockoutAnswersWrapper: {
                width: "85.50vw",
                marginTop: "2.41vw"
            },           
            singleAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "0.52",
                width: "85.50vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw",
                paddingLeft: "3.30vw",
                boxSizing: "border-box" as "border-box",
                invalid: {
                    backgroundColor: Color.CoralRed,
                    border: "1px solid " + Color.Red,
                    color: Color.Red
                }
            },
            singleAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                width: "50.72vw",
                fontWeight: "200",
                backgroundColor: Color.LightAsh,
                border: "none",
                invalid: {
                    backgroundColor: "transparent",
                    color: Color.Red
                }
            },
            buttonsWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                marginBottom: "14.15vw",
                marginTop: "9.66vw",
                back:{
                    border: "none",
                    color: Color.SharpAsh,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontWeight: "bold" as "bold",
                    fontSize: "3.86vw"
                },
                save: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginTop: "-5.52vw",
                    marginLeft: "46.00vw"         
                },
                next: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "2.41vw"
                },
                add: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw"
                },
                ok: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "1.20vw",
                    marginLeft: "82.00vw"
                }
            },
            questions: {
                width: "90.33vw",
                border: "0.48vw solid" + Color.Gainsboro,
                marginBottom: "3.62vw",
                boxSizing: "border-box" as "border-box",
                padding: "4.83vw",
                borderRadius: "2.41vw",
                transition: 'all 0.3s ease'
            },
            insideQuestion: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "6.76vw"          
            },
            questionType: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.SharpAsh,
                width: "48.30vw"
            },
            menuIcon: {
                width: "3.58vw",
                height: "3.80vw",
                fill: Color.SharpAsh,
                marginLeft: "4.98vw",
                cursor: "pointer",
                marginTop: "0.83vw"
            },
            iconGroup: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center"
            },
            checkBoxWrapper: {
                marginTop: "7.24vw",
                marginBottom: "5.00vw",
                marginLeft: "5.20vw"
            },
            checkBoxText: {
                fontSize: "3.86vw"
            },
            questionTextWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                boxSizing: "border-box" as "border-box",
                width: "80.91vw",
                paddingTop: "2.41vw",
                justifyContent: "space-between",
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.Black,
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.1"
            },
            questionAnswerWrapper: {
                borderTop: "0.10vw solid" + Color.Gainsboro,
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginTop: "1.62vw",
                paddingTop: "2.41vw",
                whiteSpace: "normal",
                wordBreak: "break-word"
            },
            answers: {
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                minWidth: "7.5vw",
                display: "flex",
                flexDirection: "row" as "row",
                flexWrap: "wrap", 
                fontSize: "3.86vw",
                justifyContent: "space-between",
                whiteSpace: "normal", 
                wordBreak: "break-word",
                lineHeight: "1.1" 
            },
            line: {
                width: "90.33vw",
                border: "2px solid" + Color.Gainsboro,
                marginTop: "7.24vw",
                marginBottom: "8.00vw"
            },                       
            questionPopup:{
                container: {                    
                    width: "100%",
                    height: "150vw",                    
                    borderRadius: "2.41vw 2.41vw 0vw 0vw",
                    padding: "1.50vw",
                    paddingTop: "4.50vw",
                    boxSizing: "border-box" as "border-box"
                },
                closeButton: {                    
                    width: "3.94vw",
                    height: "3.94vw",
                    top: "1.31vw",
                    right: "1.41vw"
                }
            },
            questionListWrapper: {
                height: "125.00vw",  
                overflowY: "scroll"
            },
            popUpForm: {
                margin: "0.52vw",
                display: "flex",
                flexDirection: "column" as "column",
                height: "auto"
            },
            searchBar: {               
                width: "100%",
                marginTop: "1.7vw",
                marginBottom: "1vw",
                paddingLeft: "1.52vw",
                paddingTop: "0.58vw",
                paddingBottom: "0.58vw",
                borderRadius: "1.69vw",
                fontSize: "2.50vw",
                boxSizing: "border-box" as "border-box"
            },
            popUpQuestionWrapper: {               
                display: "flex",
                flexDirection: "row" as "row",  
                justifyContent: "space-between",
                color: Color.DeepAsh,
                border: "0.052vw solid" + Color.Ash,
                padding: "1.78vw",
                marginBottom: "0.78vw"
            },
            questionAndAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                fontSize: "2.50vw"
            },
            questionTypeAndButton: {
                display: "flex",
                flexDirection: "column" as "column",
                justifyContent: "space-between",
                alignItems: "flex-end",
                fontSize: "2.50vw"
            },
            sampleAnswers: {
                marginTop: "0.78vw",
                marginLeft: "0.78vw"
            },
            deleteWarningDialog: {
                container: {
                    width: "calc(100% - 9.66vw)",
                    height: "61.83vw",
                    padding: "7.246vw 4.93vw",
                    borderRadius: "2.415vw 2.415vw 0 0"
                }
            },
            smsServiceDialog: {
                container: {
                    width: "calc(100% - 9.66vw)",
                    height: "30.83vw",
                    padding: "7.246vw 4.93vw",
                    borderRadius: "2.415vw 2.415vw 0 0"
                }
            },
            defaultQuestionDialog: {
                container: {
                    width: "calc(100% - 9.66vw)",
                    height: "25.83vw",
                    padding: "7.246vw 4.93vw",
                    borderRadius: "2.415vw 2.415vw 0 0"
                }
            },
            serviceMessageText: {
                marginBottom: "5vw",
                fontSize: "6.24vw",
                color: Color.LightBlack
            },
            deleteDialogTitle: {
                marginBottom: "7vw",
                fontSize: "7.24vw",
                color: Color.LightBlack
            },
            deleteButton: {
                width: "50%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "4.83vw",
                borderRadius: "2.41vw",
                margin: "7.24vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent"
                },
                red: {
                    marginRight: "2.89vw",
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.LightRed
                }
            }
        },
        replyMail: {
            mainWrapper: {
                marginLeft: "4.83vw",
                marginRight: "4.83vw"
            },
            subTittleWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                alignItems: "center",
                height: "5.79vw",
                marginTop: "8.69vw"
            },
            subTittle: {
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold",
                marginLeft: "1.35vw",
                color: Color.DeepBlack
            },
            toggleButton: {
                switch: {
                    width: "9.76vw",
                    height: "5.29vw"
                },
                switchCircle: {
                    width: "4.54vw",
                    height: "4.64vw"
                }
            },
            skipButtonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                paddingLeft: "1.56vw",
                paddingRight: "1.30vw",
                fontFamily: Font.Poppins,
                width: "24.15vw",
                height: "5.79vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                boxSizing: "border-box" as "border-box"
            },
            textInput: {
                fontSize: "3.86vw",
                marginTop: "1.20vw"
            },
            emailWrapper: {
                width: "90.33vw",
                border: "0.48vw solid" + Color.Gainsboro,
                borderRadius: "2.41vw",
                boxSizing: "border-box" as "border-box",
                marginTop: "7.24vw",
                padding: "4.83vw 2.41vw 4.83vw 2.41vw"
            },
            emailHeader: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                marginLeft: "2.41vw"
            },
            selector: {
                label: {
                    fontWeight: "300"
                },
                inputWrapper: {
                    marginTop: "1.20vw"               
                }
            },
            groupIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center"
            },
            dropup: {
                width: "0.88vw",
                height: "0.98vw"
            },
            menuIcon: {
                width: "0.83vw",
                height: "0.62vw",
                marginLeft: "1.56vw"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "column" as "column"
            },
            gropuInputWrapper: {
                width: "85.50vw",
                boxSizing: "border-box" as "border-box",
                marginTop: "4.83vw"
            },
            inputWrapper: {
                marginTop: "4.83vw"
            },
            emailTitle: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginLeft: "3.62vw",
                marginTop: "4.83vw"
            },
            coverLetterEditor: {
                minHeight: "60.86vw",
                width: "84.50vw",
                marginTop: "1.20vw",
                borderRadius: "0.52vw",
                iconWrapper: {
                    borderRadius: "0.52vw 0.52vw 0vw 0vw"
                }
            },
            notifycation: {
                fontSize: "3.86vw",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                fontWeight: "Regular" as "Regular"
            },
            label: {
                fontFamily: Font.Poppins,
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                marginLeft: "3.62vw"
            },
            emailList: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                color: Color.Black,
                border: "0.48vw solid" + Color.Gainsboro,
                width: "90.33vw",
                borderRadius: "2.41vw",
                height: "14.00vw",
                marginTop: "3.62vw",
                paddingRight: "4.83vw",
                paddingLeft: "4.83vw",
                boxSizing: "border-box" as "border-box"
            },
            editIcon: {
                width: "4.34vw",
                height: "4.34vw",
                cursor: "pointer"
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.38vw",
                fontWeight: "bold" as "bold",
                marginTop: "6.03vw",
                group: {
                    display: "flex",
                    flexDirection: "column" as "column",
                    alignItems: "center"
                },
                topRow: {
                    order: 2    
                },
                bottomRow: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "flex-end",
                    order: 1,
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    boxSizing: "border-box" as "border-box",
                    color: Color.DeepBlack,
                    width: "31.88vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.93vw",
                    fontWeight: "bold" as "bold"
                },
                submit: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    boxSizing: "border-box" as "border-box",
                    width: "50.72vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                update: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "85.50vw",
                    height: "8.45vw",
                    fontSize: "3.38vw",
                    borderRadius: "1.69vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027"
                },
                delete: {
                    color: Color.Red,
                    backgroundColor: Color.White,
                    width: "31.88vw",
                    fontSize: "3.38vw",
                    fontWeight: "bold" as "bold",
                    height: "8.45vw",
                    borderRadius: "1.93vw",
                    border: "0.48vw solid" + Color.Linen,
                    marginLeft: "20.00vw",
                    marginBottom: "3.62vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    color: Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            singleButton: {
                marginTop: "7.24vw",
                marginLeft: "13.76vw"
            },
            singleAddNewQuestionButton: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
                color: Color.White,
                width: "63.04vw",
                height: "12.07vw",
                backgroundColor: Color.DeepBlack,
                borderRadius: "2.41vw",
                boxShadow: "1.20vw 1.20vw 12.07vw  #00000027"
            },
            plusIcon: {
                fill: Color.White,
                width: "2.55vw",
                height: "2.55vw",
                marginLeft: "2.41vw"
            },
            line: {
                width: "90.33vw",
                marginTop: "7.24vw",
                border: "2px solid" + Color.Gainsboro
            },
            buttonsWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "3.86vw",
                marginBottom: "14.15vw",
                marginTop: "9.66vw",
                back:{
                    border: "none",
                    color: Color.SharpAsh,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontWeight: "bold" as "bold",
                    fontSize: "3.86vw"
                },
                save: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginTop: "-5.52vw",
                    marginLeft: "51.50vw"      
                },
                next: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "2.41vw"
                },
                add: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw"
                },
                ok: {
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "12vw",
                    height: "6.00vw",
                    borderRadius: "1.21vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "1.20vw",
                    marginLeft: "82.00vw"
                }
            },
            deleteWarningDialog: {
                container: {
                    width: "calc(100% - 9.66vw)",
                    height: "61.83vw",
                    padding: "7.246vw 4.93vw",
                    borderRadius: "2.415vw 2.415vw 0 0"
                }
            },
            deleteDialogTitle: {
                marginBottom: "7vw",
                fontSize: "7.24vw",
                color: Color.LightBlack
            },
            deleteButton: {
                width: "50%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "4.83vw",
                borderRadius: "2.41vw",
                margin: "7.24vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent"
                },
                red: {
                    marginRight: "2.89vw",
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.LightRed
                }
            }
        },
        readyToSubmit: {
            tabs: {
                marginTop: "9.66vw",
                marginLeft: "4.83vw",
                height: "9.66vw",
                width: "92.16vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "1.20vw 1.20vw 1.20vw 1.20vw",
                display: "flex"
            },
            tab: {
                height: "9.66vw",
                fontSize: "3.86vw",
                borderRadius: "1.20vw 1.20vw 1.20vw 1.20vw",
                padding: "2.89vw 4.03vw 2.89vw 4.03vw",
                backgroundColor: "transparent",
                color: Color.DeepAsh, 
                cursor: "pointer",
                transition: "all 0.3s ease",
            },
            tabActive: {
                backgroundColor: Color.DeepBlack,
                color: Color.LightAsh
            },
            line: {
                border: "0.24vw solid" + Color.Gainsboro,
                marginBottom: "9.66vw",
                marginTop: "4.80vw",
                width: "90.33vw"
            },
            buttonsWrapper: {
                flexwrap: "",
                marginBottom: "0vw",
                marginTop: "0vw",
                width: "90.33vw",
                marginLeft: "4.83vw",
                back:{
                    border: "none",
                    color: Color.SharpAsh,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontWeight: "bold" as "bold",
                    fontSize: "3.86vw"
                },
                next: {
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "43.96vw",
                    height: "9.66vw",
                    borderRadius: "2.41vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "2.41vw"
                },
                viewButton: {
                    color: Color.LightBlack,
                    backgroundColor: Color.White,
                    width: "85.50vw",
                    height: "7.24vw",
                    border: "2px solid" + Color.Gainsboro,
                    borderRadius: "1.69vw",
                    fontSize: "2.89vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "1.20vw 1.20vw 12.07vw #00000027",
                    marginLeft: "7.24vw",
                    marginTop: "3.62vw"
                }
            },
            jobSubmisionDialog: {
                container: {
                    width: "90%",
                    display: "flex",
                    flexDirection: "column" as "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "75.38vw",
                    borderRadius: "2.41vw",
                    padding: "6.83vw 4.83vw 4.83vw 4.83vw"
                }
            },
            jobViewButton: {
                width: "70.0483vw",
                height: "12.077vw",
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                borderRadius: "2.41vw",
                marginTop: "6.76vw",
                marginBottom: "11.83vw",
                color: Color.White,
                backgroundColor: Color.Blue
            },
            tickMark: {
                width: "30.36vw",
                height: "30.36vw",
                marginTop: "-18.50vw"
            },
            popupText: {
                width: "90%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                marginTop: "2.89vw"
            },
            deleteDialogTitle: {
                fontWeight: "bold" as "bold",
                marginTop: "2.41vw",
                textAlign: "center",
                fontSize: "7.24vw",
                color: Color.LightBlack
            }
        },
        summaryOfCompletion: {
            fullWrapper: {
                width: "90.33vw",
                minHeight: "32.71vw",
                border: "0.24vw solid" + Color.Blue,
                backgroundColor: Color.LightBlue,
                borderRadius: "2.41vw",
                marginLeft: "4.83vw",
                marginTop: "4.83vw"
            },
            tittle: {
                fontSize: "3.86vw",
                fontWeight: "500",
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                marginTop: "3.62vw",
                marginLeft: "3.62vw"              
            },
            mainWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginLeft: "9.17vw"
            },
            infoWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginBottom: "0.52vw",
                marginTop: "3.62vw"
            },
            logoWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "center",
                width: "8.45vw",
                height: "8.45vw",
                backgroundColor: Color.Gainsboro,
                borderRadius: "1.20vw",
                present: {
                    backgroundColor: Color.Blue
                },
                complete: {
                    backgroundColor: Color.DeepBlack
                },
                finalStage: {
                    backgroundColor: Color.LightBlue
                }
            },
            logoBag: {
                width: "4.34vw",
                height: "4.12vw",
                semiLine: {
                    borderTop: "0.50vw dashed" + Color.LightSilver,
                    width: "9.66vw",
                    marginTop: "4.22vw",
                    marginLeft: "1.44vw",
                    marginRight: "1.44vw",
                    complete: {
                        borderTop: "0.50vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "0.50vw dashed" + Color.Blue
                    }
                }
            },
            logoQuestionMark: {
                width: "2.91vw",
                height: "4.24vw",
                semiLine: {
                    borderTop: "0.50vw dashed" + Color.LightSilver,
                    width: "9.66vw",
                    marginTop: "4.22vw",
                    marginLeft: "1.44vw",
                    marginRight: "1.44vw",
                    complete: {
                        borderTop: "0.50vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "0.50vw dashed" + Color.Blue
                    }
                }
            },
            logoMail: {
                width: "4.42vw",
                height: "3.23vw",
                fill: Color.White,
                semiLine: {
                    borderTop: "0.50vw dashed" + Color.LightSilver,
                    width: "9.66vw",
                    marginTop: "4.22vw",
                    marginLeft: "1.44vw",
                    marginRight: "1.44vw",
                    complete: {
                        borderTop: "0.50vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "0.50vw dashed" + Color.Blue
                    }
                }
            },
            logoTumbUp: {
                width: "4.83vw",
                height: "4.65vw",
                fill: Color.White,
                finalStage: {
                    fill: Color.DeepBlack
                }
            },
            submitButton: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "72.94vw",
                height: "8.45vw",
                borderRadius: "1.69vw",
                backgroundColor: Color.White,
                fontWeight: "800",
                fontSize: "3.38vw",
                marginLeft: "8.69vw",
                color: Color.Black,
                marginTop: "3.62vw",
                marginBottom: "4.83vw",
                boxShadow: "1.20vw 1.20vw 12.0vw #00000027"
            },
            textWhite: { color: Color.White },
            svgWhite: { filter: "brightness(0) invert(1)" },
            backgroundBlue: { backgroundColor: Color.Blue },
            backgroundBlack: { backgroundColor: Color.DeepBlack }
        }
    },
    desktop: {
        mainWrapper: {
            flexDirection: "row" as "row",
            paddingLeft: "1.56vw",
            paddingTop: "1.56vw"
        },
        leftWrapper: {
            width: "19.27vw" 
        },
        rightWrapper: {
            marginLeft: "7.52vw",
            width: "70.52vw",
            paddingRight: "1.56vw",
            boxSizing: "border-box" as "border-box" 
        },
        innerRightWrapper: {
            display: "flex",
            flexDirection: "row-reverse" as "row-reverse",
        },
        topic: {
            fontSize: "2.60vw",
            marginLeft: "0.57vw",
            color: Color.DeepBlack
        },
        buttonIcon: {
            width: "0.83vw",
            height: "0.83vw",
            marginLeft: "0.26vw",
        },
        profileWrapper: {
            display: "flex",
            marginLeft: "auto"
        },
        pageHeader: {
            marginLeft: "-6.05vw",
            marginBottom: "-1.70vw",
            marginTop: "0vw",
        },
        backButton: {
            width: "3.60vw",
            height: "3.60vw",    
            backgroundColor: Color.BrightGray    
        },
        buttonTittle: {
            display: "none"
        },
        basicDetails: {
            mainWrappre: {
                width: "42.29vw",
                boxSizing: "border-box" as "border-box"
            },        
            subTopicWrapper: {
                marginTop: "1.56vw",
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                topic: {
                    fontSize: "1.04vw",
                    fontWeight: "bold" as "bold",
                    color: Color.LightBlack,
                    marginLeft: "0.57vw"
                },
                text: {
                    marginLeft: "0.41vw",
                    fontSize: "0.83vw",
                    color: Color.DeepAsh,
                    cursor: "pointer"
                }
            },
            buttonGroup: {
                marginLeft: "23.60vw",
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center"
            },
            radioButton: {
                radioButton: {
                    width: "0.68vw",
                    height: "0.68vw",
                    marginLeft: "0.86vw"
                }
            },
            textInput: {
                marginTop: "0.18vw",
                fontSize: "0.93vw"
            },
            cvLimit: {
                width: "20.72vw",
                marginTop: "0.18vw",
                fontSize: "0.93vw"
            },
            label: {
                fontSize: "0.937vw",
                marginLeft: "0.52vw",
                marginBottom: "0vw",
                fontWeight: "200"
            },
            inputWrapper: {
                marginTop: "1.30vw"
            },
            dateWrapper: {
                marginTop: "1.30vw"
            },
            dateInput: {
                marginTop: "0.30vw",
                width: "20.72vw",
                height: "3.64vw",
                border: "none",
                borderRadius: "0.52vw",
                fontSize: "0.937vw",
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw"
            },
            benifitContainer: {
                width: "100%",
                minHeight: "3.64vw",
                paddingTop: "0.78vw",
                paddingLeft: "0.78vw",
                paddingBottom: "0.78vw",
                borderRadius: "0.52vw",
                gap: "0.5vw",
                hover: {
                    border: "0.05vw solid" + Color.Black
                }
            },
            searchContainer: {
                minHeight: "3.64vw",
                paddingTop: "0.78vw",
                paddingLeft: "0.78vw",
                gap: "0.5vw",
                paddingBottom: "0.48vw",
                borderRadius: "0.52vw", 
                hover: {
                    border: "0.05vw solid" + Color.Black
                }
            },
            customerWrapper: {
                width: "100%",
                height: "2.20vw",
                border: "0.10vw solid" + Color.LightGray,
                fontSize: "0.937vw",
                borderRadius: "0.52vw",
                marginTop: "0.52vw",
                paddingLeft: "0.52vw",
                boxSizing: "border-box" as "border-box",
                hover: {
                    border: "0.vw solid" + Color.Black
                }
            },
            customBenifit: {
                width: "95%",
                border: "none",
                fontSize: "0.937vw"    
            },
            addButton: {
                display: "none"
            },
            benifitHoverWrapper: {
                width: " 42.00vw",
                paddingBottom: "0.78vw",
                paddingTop: "0.78vw",
                paddingLeft: "0.98vw",
                paddingRight: "0.98vw",
                borderRadius: "0 0 0.52vw 0.52vw",
                border: "0.05vw solid" + Color.LightAsh
            },
            levelHoverWrapper: {
                width: "20.72vw",
                boxSizing: "border-box" as "border-box",
                paddingBottom: "1.04vw",
                paddingTop: "0.36vw",
                paddingLeft: "0.66vw",
                paddingRight: "0.36vw",
                borderRadius: "0 0 0.52vw 0.52vw",
                zIndex: "1",
                height: "auto", 
                maxHeight: "12.00vw",     
            },
            levelScrollArea: {
                maxHeight: "10.00vw"
            },
            levelDropDownItem: {
                fontSize: "0.93vw", 
                fontWeight: "500",
                paddingTop: "0.56vw",
                paddingLeft: "0.56vw",
                color: Color.DeepAsh,     
                height: "1.40vw",
                hover: {
                    borderRadius: "0.36vw"
                }
            },
            selector: {
                label: {
                    fontWeight: "200"
                }
            },
            benifitbottomBorder: {
                border: 0,
                width: "98%",
                height: "1px",
                zIndex: "1",
                hover: {
                    background: Color.LightAsh
                }
            },
            levelBottomBorder: {
                border: 0,
                height: "1px",
                width: "95%",
                zIndex: "1",
                hover: {
                    background: Color.LightAsh
                }
            },
            dropdownItem: {
                fontSize: "0.93vw", 
                fontWeight: "500",
                marginBottom: "0vw",
                height: "1.50vw",
                paddingLeft: "0.51vw",
                boxSizing: "border-box" as "border-box",
                hover: {
                    borderRadius: "0.36vw",
                    paddingBottom: "0.51vw"
                }
            },
            groupWrapper: {
                marginTop: "0vw",
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%"       
            },
            searchInput: {
                fontSize: "0.93vw",
                border: "none",
                width: "8vw",
                marginBottom: "0.5vw"
            },
            rightMargin: {
                marginRight: "0.41vw"
            },
            leftMargin: {
                marginLeft: "0.41vw"
            },
            topMargin: {
                display: "flex",
                height: "5.74vw",
                flexDirection: "row" as "row",
                alignItems: "flex-end",
                justifyContent: "space-between",
                marginTop: "1.04vw",
            },
            cvLimitWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
            },
            tabSwitch: {
                switch: {
                    borderRadius: "0.93vw",
                    height: "1.87vw",
                    width: "3.22vw",
                    padding: "0.26vw",
                    boxSizing: "border-box" as "border-box",
                    marginLeft: "2.5vw"
                },
                switchCircle: {
                    height: "1.35vw",
                    width: "1.35vw"
                }
            },
            textAreaInputWrapper: {
                marginTop: "0.78vw"                
            },
            textAreaInput:{
                marginTop: "0.52vw",
                textArea: {
                    width: "100%",
                    minHeight: "6.61vw"
                }
            },
            buttonWrapper: {
                fontSize: "0.93vw",
                border: "0.052vw solid" + Color.LightGray,
                padding: "0.9vw 1.5vw 0.9vw 1.5vw",
                borderRadius: "0.52vw"
            },
            cvBaseWrapper: {
                fontSize: "0.93vw",
                border: "0.052vw solid" + Color.LightGray,
                padding: "0.9vw 1.5vw 0.9vw 1.5vw",
                borderRadius: "0.52vw",
                width: "17.62vw",
                monthly: {
                    width: "100%"
                }
            },
            inputWithLogo: {
                justifyContent: "center",
                fontSize: "0.93vw",
                height: "3.64vw",
                width: "20.72vw",
                borderRadius: "0.52vw",
                paddingLeft: "0vw",
                paddingRight: "0vw",
                marginBottom: "0vw"
            },
            input: {
                fontSize: "0.93vw"
            },
            groupIcon: {
                marginLeft: "0vw"
            },
            icon: {
                width: "0.88vw",
                height: "0.98vw"
            },
            uploadWrapper: {
                width: "3.64vw"
            },
            uploadIcon: {
                width: "0.85vw",
                height: "0.85vw",
                color: Color.Black,
                marginLeft: "30.00vw"
            },
            instructionArea: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between"
            },
            instruction: {
                fontSize: "0.83vw",
                marginTop: "0.52vw",
                marginLeft: "0.52vw"
            },
            imageText: {
                fontSize: "0.83vw",
                marginTop: "0.52vw",
                marginRight: "2.00vw",
                marginLeft: "0vw"
            },
            textMedium: {
                ontSize: "0.83vw",
                fontWeight: "800"                
            },
            line1: {
                border: "0.10vw solid" + Color.Gainsboro,
                marginTop: "2.08vw",
                marginBottom: "2.08vw"
            },
            line2: {
                border: "0.10vw solid" + Color.Gainsboro,
                marginTop: "2.08vw",
                marginBottom: "2.08vw"
            },
            form: {
                paddingLeft: "0vw",
                paddingRight: "0vw"
            },
            buttonsWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontSize: "0.83vw",
                back: {
                    fontSize: "0.83vw",
                    position: "none" as "none",
                    top: "0",
                    left: "0",
                    border: "0.20vw solid" + Color.SharpAsh,
                    width: "5.62vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginLeft: "0.52vw"    
                },
                next: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "24.15vw"      
                },
                save: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "30.15vw",
                    marginTop: "-1vw"     
                }
            },
            coverLetterEditor: {
                minHeight: "22.76vw",
                width: "42.23vw",
                border: "0.05vw solid" + Color.MiddleAsh,
                marginTop: "0.62vw",
                borderRadius: "0.52vw",
                iconWrapper: {
                    borderRadius: "0.52vw 0.52vw 0vw 0vw"
                }
            },
            labelWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center"
            },
            aiLbelWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontSize: "0.83vw",
                color: Color.White,
                backgroundColor: Color.PurplePlum,
                marginLeft: "1.25vw",
                padding: "0.42vw 0.52vw 0.42vw 0.52vw",
                borderRadius: "0.32vw"
            },
            aiLogo: {
                width: "1.00vw",
                height: "1.00vw",
                fill: Color.White,
                marginLeft: "1.25vw"
            },
            sectorContainer: {
                borderRadius: "0.52vw",
                padding: "1.25vw 1.25vw 1.00vw 1.25vw"
            },
            selectorWrapper: {
                maxWidth: "calc(100% - 2.08vw)", 
                width: "fit-content",
                minHeight: "1.822vw",
                paddingLeft: "1.04vw",
                paddingRight: "1.04vw", 
                paddingTop: "0.3vw", 
                paddingBottom: "0.3vw",
                lineHeight: "1.4", 
                fontSize: "0.78vw",
                borderRadius: "6.04vw", 
                flex: "0 0 auto"
            },
            closeIcon: {
                right: "0.2vw",
                height: "1.04vw",
                width: "1.04vw"
            },
            allSectorWrapper: {
                width: "7.39vw",
                overflow: "visible",
                verticalAlign: "bottom",
                position: "relative"
            },
            hoverWrapper: {
                position: "absolute",
                paddingTop: "0.78vw",
                left: "-35%",
                zIndex: "1"
            },
            search: {
                height: "1.562vw",
                fontSize: "0.72vw",
                marginTop: "0.52vw",
                icon: {
                    width: "0.62vw",
                    height: "0.62vw",
                    left: "4.60vw",
                    top: "2.40vw"
                }
            },
            scrollArea: {
                marginTop: "0.52vw"
            },
            option: {
                margin: "0",
                padding: "0.312vw 0.52vw",
                fontSize: "0.78vw",
                hover: {
                    borderRadius: "0.36vw"
                }
            },
            hover: {
                width: "15.15vw",
                borderRadius: "0.52vw",
                height: "15.67vw",
                padding: "0.52vw",
                position: "unset"
            },
            redCloseIcon: {
                height: "1.04vw",
                width: "1.04vw",
                marginLeft: "0.5vw",
                cursor: "pointer"
            },
            attachment: {
                marginTop: "0.52vw",
                selectedFileName: {
                    fontSize: "0.93vw",
                    margin: "1.19vw 0 1.14vw 1.56vw"
                },
                fileIcon: {
                    marginRight: "1.51vw"
                }
            },
            uploadedImage: {
                objectFit: "contain"
            },
            uploadImagePopup: {
                zIndex: "11",
                container: {
                    padding: "0.78vw",
                    maxWidth: "35vw",
                    maxHeight: "93%",
                    width: "auto",
                    height: "auto",
                    bottom: "unset"
                }
            }
        },
        vacancyQuestion: {
            mainWrapper: {
                width: "43.95vw",
                boxSizing: "border-box" as "border-box"
            },
            subTopicWrapper: {
                marginTop: "1.56vw",
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                topic: {
                    marginTop: "0vw",
                    fontSize: "1.04vw",
                    fontWeight: "bold" as "bold",
                    marginLeft: "0.70vw"
                },
                circle: {
                    width: "0.41vw",
                    height: "0.41vw",
                    backgroundColor: Color.Red,
                    borderRadius: "50%",
                    marginLeft: "20.83vw"
                },
                text: {
                    marginLeft: "0.31vw",
                    fontSize: "0.83vw"
                }
            },
            form: {
                marginLeft: "-0.9vw",
                paddingLeft: "0vw",
                paddingRight: "0vw",
                minHeight: "auto"
            },
            inputWrapper: {
                marginTop: "0.52vw",
                width: "100%"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center"
            },
            rightMargin: {
                marginRight: "0.41vw"
            },
            leftMargin: {
                marginLeft: "0.41vw"
            },
            textInput: {
                marginTop: "0.18vw",
                fontSize: "0.93vw"
            },
            passScore: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                boxSizing: "border-box" as "border-box",
                width: "43.95vw",
                height: "6.40vw",
                border: "0.15vw solid" + Color.Green,
                borderRadius: "0.52vw",
                marginTop: "1.56vw",
                fontWeight: "500",
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                paddingLeft: "2.08vw"                
            },
            passScoreText: {
                fontSize: "0.93vw",
                marginTop: "2.60vw",
                width: "28.48vw",
                height: "3.64vw"
            },
            passScoreInvlidText: {
                fontSize: "0.93vw",
                color: Color.Red,
                width: "23.10vw"
            },
            passScoreInput: {
                width: "11.30vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                marginLeft: "0vw",
                paddingLeft: "1.45vw",
                paddingRight: "1.56vw",
                input: {
                    width: "6.56vw",
                    active: {
                        backgroundColor: Color.White,
                        border: "none"
                    }
                },
            },
            inputError: {
                fontSize: "1vw",
                border: "1px solid red",
                icon: {
                    width: "1.05vw",
                    height: "1.05vw"
                }
            },
            notifyMailWrapper: {
                fontSize: "0.93vw",
                paddingLeft: "0vw",
                marginTop: "0.52vw",
                width: "23.10vw"
            },
            policyLabel: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw"
            },
            groupIcon: {
                icon: {
                    width: "0.88vw",
                    height: "0.88vw"
                },
                arrow: {
                    width: "0.68vw",
                    height: "0.98vw"
                }
            },
            addNewQuestionWrapper: {
                marginTop: "1.56vw",
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw",    
                fontSize: "0.93vw",
                width: "43.95vw"    
            },
            frequenltyQuestionButton: {
                fontSize: "0.83vw",
                width: "14.2vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                marginRight: "1.25vw",
                marginLeft: "7.55vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            addNewQuestionButton: {
                fontSize: "0.83vw",
                width: "13.59vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            singleAddNewQuestionButton: {
                fontSize: "0.83vw",
                width: "13.59vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            selectedQuetionsDeleteButton: {
                width: "auto",
                fontSize: "0.83vw",
                height: "2.60vw",
                borderRadius: "0.41vw",
                border: "0.10vw solid" + Color.Linen,
                marginBottom: "0vw"
            },
            singleButton: {
                marginTop: "1.56vw",
                marginLeft: "0.83vw"
            },
            plusIcon: {
                width: "0.78vw",
                height: "0.68vw",
                marginLeft: "0.52vw"
            },
            addNewquestion: {
                width: "43.95vw",
                border: "0.156vw solid" + Color.Gainsboro,
                marginTop: "1.82vw",
                padding: "1.04vw 0.83vw 1.56vw 0.83vw",
                borderRadius: "0.52vw"
            },
            qusetionTittle: {
                fontFamily: Font.Poppins,
                fontWeight: "bold" as "bold",
                color: Color.DeepAsh,
                fontSize: "0.93vw"     
            },
            checkBoxGroup: {
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center"
            },
            questionWrapper: {
                display: "flex",
                flexDirection: "row" as "row"    
            },
            selectorWrapper: {
                width: "13.54vw"
            },
            selector: {
                mainWrapper: {
                    width: "13.54vw",
                    marginTop: "0.52vw"
                },
                label: {
                    fontWeight: "200"
                },
                inputWrapper: {
                    backgroundColor: Color.White,
                    border: "0.10vw solid" + Color.SharpAsh,
                    height: "3.64vw",
                    marginTop: "0.15vw"               
                },
                input: {
                    width: "9.00vw",
                    marginLeft: "1.56vw"
                },
                icon: {
                    width: "5.88vw",
                    height: "5.98vw"
                },
                answer: {
                    mainWrapper: {
                        width: "20.72vw"
                    },
                    inputWrapper: {
                        marginTop: "0.15vw",
                        backgroundColor: Color.White,
                        border: "0.10vw solid" + Color.SharpAsh
                    },
                    label: {
                        fontWeight: "200"
                    },
                    dropdownWrapper: {
                        height: "4.00vw",
                        overflow: "visible"
                    }
                }
            },
            label: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                fontWeight: "Regular" as "Regular",
                color: Color.DeepAsh,
                marginLeft: "0.52vw"
            },
            answerWrapper: {
                marginTop: "1.04vw"
            },
            yesNoType: {
                
            },
            openQuestionText: {
                fontSize: "0.83vw",
                marginLeft: "6.82vw",
                marginTop: "2vw",
                fontWeight: "200"
            },
            addYesNoAnswer: {
                height: "5.46vw"
            },
            addMultipleChoiceAnswer: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            addKnoctoutAnswer: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            addsingleChoiceAnswer: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            multipleAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "0.15vw",
                width: "20.72vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                paddingLeft: "1.56vw"
            },
            multipleAnswer: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",          
                fontWeight: "200",
                height: "2.00vw",
                backgroundColor: Color.LightAsh,
                border: "none",
                borderRight: "0.10vw solid" + Color.Gainsboro
            },
            multipleScore: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                fontWeight: "200",
                width: "4.42vw",
                backgroundColor: Color.LightAsh,
                border: "none",
                marginLeft: "1.56vw"               
            },
            multiplChoiceAddButton: {
                width: "7.91vw",
                height: "1.82vw",
                fontSize: "0.72vw",
                borderRadius: "0.36vw",
                marginLeft: "12.81vw",
                marginTop: "0.52vw",
                marginBottom: "0vw"
            },
            totalScoreWrapper: {
                fontSize: "0.83vw",
                fontWeight: "500",
                paddingRight: "1.9vw"
            },
            buttonWrapper: {
                fontSize: "0.72vw",
                marginTop: "1.56vw",
                group: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    alignItems: "center"
                },
                topRow: {
                    order: 1    
                },
                bottomRow: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    justifyContent: "flex-end",
                    order: 1,
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.10vw solid" + Color.DeepBlack, 
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.41vw"
                },
                submit: {
                    width: "10.93vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                update: {
                    width: "10.93vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                delete: {
                    width: "6.35vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.41vw",
                    border: "0.10vw solid" + Color.Linen,
                    marginLeft: "17.81vw",
                    marginBottom: "0vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            answersLabelWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "15.88vw",
                paddingRight: "1.2vw"
            },
            answerAndScoreMainWrapper: {
                width: "15.88vw",
                boxSizing: "border-box" as "border-box"
            },
            answerAndScoreWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "0.83vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginBottom: "0.52vw",
                justifyContent: "space-between",
                paddingLeft: "0.6vw"                           
            },
            textWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                fontFamily: Font.Poppins,
                fontSize: "0.83vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                marginLeft: "1.04vw"                     
            },
            deleteIcon: {
                width: "0.78vw",
                height: "0.78vw",
                marginLeft: "1.1vw"               
            },
            labelWithIcon: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingRight: "1vw"
            },
            knockoutAnswerWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                marginTop: "0.15vw",
                width: "24.53vw",
                height: "3.64vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "0.52vw",
                paddingLeft: "1.56vw",
                boxSizing: "border-box" as "border-box"
            },
            KnockoutAddButton: {
                width: "7.91vw",
                height: "1.82vw",
                fontSize: "0.72vw",
                color: Color.Green,
                fontWeight: "bold" as "bold",
                backgroundColor: Color.Nyanza,
                borderRadius: "0.36vw",
                marginLeft: "16.61vw",
                marginTop: "0.52vw"
            },
            radioButton: {
                radioButton: {
                    width: "0.68vw",
                    height: "0.68vw"
                },
            },
            radioButtonGrop: {
                width: "3.69vw",
                height: "1.30vw",
                marginLeft: "0.50vw"
            },
            radioButtonText: {
                fontSize: "0.93vw",
                marginLeft: "0.52vw",
                clicked: {
                    color: Color.DeepBlack
                } 
            },
            knockoutAnswersWrapper: {
                width: "15.88vw",
                marginTop: "0vw"
            },
            knoctoutAnswer: {
                fontFamily: Font.Poppins,
                fontSize: " 0.93vw",
                fontWeight: "300",
                color: Color.DeepAsh,
                backgroundColor: Color.LightAsh,
                border: "none",
                width: "13.28vw",
                height: "1.77vw",
                borderRight: "0.10vw solid" + Color.Gainsboro
            },
            knockoutAnswerLabelWrapper: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                fontWeight: "500",
                color: Color.DeepAsh,
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "15.88vw",
                paddingRight: "1.2vw",
                boxSizing: "border-box" as "border-box"
            },
            singleChoiceText: { 
                fontSize: "0.83vw",
                fontWeight: "800"
            },
            singleAnswerWrapper: {
                marginTop: "0.15vw",
                width: "24.53vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                paddingLeft: "1.56vw"
            },
            singleAnswer: {
                fontSize: "0.93vw",
                width: "15.88vw",
                fontWeight: "500",
                border: "none",
                color: Color.DeepAsh,
                borderRight: "0.10vw solid" + Color.Gainsboro
            },
            buttonsWrapper: {
                flexwrap: "",
                fontSize: "0.83vw",
                marginBottom: "0vw",
                marginTop: "0vw",
                width: "43.12vw",
                back:{
                    fontSize: "0.83vw",
                    position: "none" as "none",
                    top: "0",
                    left: "0",
                    border: "0.20vw solid" + Color.SharpAsh,
                    color: Color.SharpAsh,
                    width: "5.62vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginLeft: "1.35vw"    
                },
                next: {
                    fontSize: "0.83vw",
                    color: Color.White,
                    backgroundColor: Color.Green,
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "25.35vw"    
                },
                add: {
                    color: Color.White,
                    width: "5.93vw",
                    height: "1.82vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw",
                    fontSize: "0.83vw"
                },
                save: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "31.15vw",
                    marginTop: "-1.5vw"      
                },
                ok: {
                    fontSize: "0.93vw",
                    color: Color.White,
                    backgroundColor: Color.Blue,
                    width: "5.93vw",
                    height: "2.30vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.28vw",
                    marginLeft: "42.80vw"
                }
            },
            questions: {
                width: "43.95vw",
                border: "0.156vw solid" + Color.Gainsboro,
                marginBottom: "1.82vw",
                boxSizing: "border-box" as "border-box",
                padding: "1.04vw 0.83vw 1.56vw 0.83vw",
                borderRadius: "0.52vw"
            },
            insideQuestion: {
                display: "flex",
                flexDirection: "row" as "row",
                paddingLeft: "1.04vw",
                marginTop: "0.83vw"
            },
            questionType: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                width: "4.00vw"
            },
            menuIcon: {
                width: "0.88vw",
                height: "0.62vw",
                fill: Color.SharpAsh,
                marginLeft: "1.51vw",
                marginTop: "0vw"
            },
            iconGroup: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "center"
            },
            checkBoxWrapper: {
                marginTop: "1.56vw",
                marginBottom: "1.00vw",
                marginLeft: "1.00vw"
            },
            checkBoxText: {
                fontSize: "0.93vw"
            },
            questionTextWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                boxSizing: "border-box" as "border-box",
                borderLeft: "0.10vw solid" + Color.Gainsboro,
                width: "36.71vw",
                paddingLeft: "1.04vw",
                paddingTop: "0",
                margin: "0 1.04vw 0 1.04vw",
                justifyContent: "space-between",
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh
            },
            questionAnswerWrapper: {
                paddingLeft: "1.04vw",
                borderTop: "",
                borderLeft: "0.10vw solid" + Color.Gainsboro,
                fontSize: "0.93vw",
                marginTop: "0vw",
                paddingTop: "0vw"                       
            },
            answers: {
                maxWidth: "20vw",
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                marginBottom: "0.31vw",
                fontSize: "0.83vw",
                score: {
                    marginLeft: "0.78vw"
                }
            },
            line: {
                width: "42.29vw",
                border: "0.052vw solid" + Color.Gainsboro,
                marginTop: "1.56vw",
                marginLeft: "0.83vw",
                marginBottom: "2.7vw"
            },                       
            questionPopup:{
                container: {                    
                    width: "52.99vw",
                    height: "43.85vw",                    
                    borderRadius: "0.52vw",
                    padding: "0.83vw",
                    paddingTop: "0"   
                },
                closeButton: {                    
                    width: "0.94vw",
                    height: "0.94vw",
                    top: "0.61vw",
                    right: "0.41vw"
                }
            },
            questionListWrapper: {
                height: "35.00vw",  
                overflowY: "scroll"
            },
            popUpForm: {
                margin: "0.52vw",
                display: "flex",
                flexDirection: "column" as "column",
                height: "auto"
            },
            searchBar: {               
                width: "100%",
                marginTop: "1.5vw",
                marginBottom: "1vw",
                paddingLeft: "1.52vw",
                paddingTop: "0.58vw",
                paddingBottom: "0.58vw",
                fontSize: "1.04vw",
                backgroundColor: Color.Cultured,
                borderRadius: "0.52vw",
                boxSizing: "border-box" as "border-box"
            },
            popUpQuestionWrapper: {               
                display: "flex",
                flexDirection: "row" as "row",  
                justifyContent: "space-between",
                color: Color.DeepAsh,
                border: "0.052vw solid" + Color.Ash,
                padding: "0.78vw",
                marginBottom: "0.78vw",
                fontSize: "1.04vw"
            },
            questionAndAnswer: {
                display: "flex",
                flexDirection: "column" as "column",
                fontSize: "0.93vw"
            },
            questionTypeAndButton: {
                display: "flex",
                fontSize: "0.93vw"
            },
            sampleAnswers: {
                marginTop: "0.78vw",
                marginLeft: "0.78vw"
            },
            deleteWarningDialog: {
                container: {
                    width: "22.00vw",
                    height: "13.00vw",
                    borderRadius: "0.52vw",
                    padding: "2vw 2vw"
                }
            },
            deleteDialogTitle: {
                fontSize: "1.56vw",
                color: Color.LightBlack,
                marginBottom: "1.51vw"
            },
            deleteButton: {
                width: "10.15vw",
                height: "2.604vw",
                fontSize: "1.041vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent"
                },
                red: {
                    marginRight: "0.625vw",
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.Linen
                }
            }
        },
        cvLessQuestion: {
            mainWrapper: {
                marginLeft: "-0.9vw"
            },
            subTopicWrapper: {
                marginTop: "1.56vw",
                display: "flex",
                flexDirection: "row" as "row",
                alignItems: "center",
                topic: {
                    fontSize: "1.04vw",                    
                    marginTop: "0vw",
                    marginLeft: "1.50vw"
                },
                circle: {
                    width: "0.41vw",
                    height: "0.41vw",
                    backgroundColor: Color.Red,
                    borderRadius: "50%",
                    marginLeft: "20.83vw"
                },
                text: {
                    marginLeft: "0.31vw",
                    fontSize: "0.83vw"
                }
            },
            serviceWrapper: { 
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between",
                width: "43.95vw",
                height: "5.31vw",
                marginTop: "1.56vw",
                border: "0.15vw solid" + Color.MiddleAsh,                                
                borderRadius: "0.52vw",
                padding: "1.19vw 1.04vw 1.19vw 1.35vw",
                marginBottom: "0"
            },
            Topic: {
                fontFamily: Font.Poppins,
                color: Color.DeepAsh,
                fontSize: "0.93vw"
            },
            subTopic: {
                fontSize: "0.93vw"
            },
            tabSwitch: {
                switch: {
                    borderRadius: "0.93vw",
                    height: "1.87vw",
                    width: "3.22vw",
                    padding: "0.26vw",
                    boxSizing: "border-box" as "border-box"
                },
                switchCircle: {
                    height: "1.35vw",
                    width: "1.35vw"
                }
            },
            smsServiceMainWrapper: {                
                width: "43.95vw",
                marginTop: "1.82vw",
                borderRadius: "0.52vw",
                padding: "1.04vw 0.83vw 1.56vw 0.83vw",
                boxSizing: "border-box" as "border-box",
                border: "0.15vw solid" + Color.Gainsboro
            },
            smsServiceTittle: {
                fontFamily: Font.Poppins,                
                marginLeft: "0.52vw",
                color: Color.DeepAsh,
                fontSize: "0.93vw"     
            },
            textAreaWrapper: {
                marginTop: "0.52vw"
            },
            textAreaInput:{
                marginTop: "0.52vw",
                marginBottom: "0.52vw",
                textArea: {
                    width: "100%",
                    height: "4.23vw", 
                    minHeight: "8.00vw"
                },
                inputField: {
                    height: "5.20vw"
                }
            },
            showTags: {
                marginTop: "0.26vw",                                
                marginLeft: "36.50vw",                
                fontSize: "0.93vw"
            },
            showTagWrapper: {
                container: {
                    width: "24.00vw",
                    height: "13.00vw",
                    borderRadius: "0.52vw",
                    padding: "2vw 2vw 2vw 2vw"
                }
            },
            tagTextAndIconWrapper: {
                marginTop: "0vw"
            },            
            duplicateIcon: {
                width: "1.04vw",
                height: "1.04vw",
                marginLeft: "1.04vw"
            },
            tagTextAndIcon: {                
                marginTop: "0.75vw",                
                fontSize: "1.00vw",   
                height: "1.1"
            },
            dateWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "1.30vw",
                marginBottom: "1vw",
                width: "100%",
                height: "5.46vw"                
            },
            dateInputWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                width: "36.45vw",
                boxSizing: "border-box" as "border-box"
            },
            dateInput: {
                marginTop: "0.30vw",
                marginRight: "0.83vw",
                height: "3.64vw",
                border: "none",
                borderRadius: "0.52vw",
                fontSize: "0.937vw",                                
                width: "35.16vw",                
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw"                
            },
            locationWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "1.04vw",
                height: "5.46vw",
                marginBottom: "1.04vw",
                justifyContent: "space-between",
                alignItems: "flex-start",    
                boxSizing: "border-box" as "border-box"
            },
            locationAnswerWrapper: {                
                marginBottom: "0.52vw",
                marginTop: "0vw"
            },
            answerGruop: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            locationAnswer: {                
                fontSize: "0.93vw",                                
                width: "17.08vw",
                marginRight: "1.04vw",
                marginLeft: "0.52vw",
            },
            locationInputWrapper: {
                width: "17.08vw",
                marginTop: "0vw",
                height: "5.46vw",
                boxSizing: "border-box" as "border-box"
            },
            locationAddButton: {
                fontSize: "0.93vw",
                marginTop: "1.7vw",                                
                width: "5.62vw",
                height: "3.50vw",
                borderRadius: "0.52vw",                
                marginLeft: "0vw"
            },
            interviewDateAddButton: {
                fontSize: "0.93vw",
                marginTop: "1.70vw",                
                width: "5.62vw",
                height: "3.64vw",
                borderRadius: "0.52vw",                
                marginLeft: "0vw"
            },
            smsSave: {
                fontSize: "0.83vw",
                marginTop: "2.60vw",                
                width: "8.93vw",
                height: "1.82vw",
                borderRadius: "0.52vw",                
                marginLeft: "33.00vw" 
            },
            form: {
                paddingLeft: "0vw",
                paddingRight: "0vw"
            },
            inputWrapper: {
                marginTop: "0.52vw",
                width: "100%"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "row" as "row"                
            },
            rightMargin: {
                marginRight: "0.41vw"
            },
            leftMargin: {
                marginLeft: "0.41vw"
            },
            textInput: {
                display: "flex",
                alignItems: "center",
                marginTop: "0.18vw",
                height: "3.64vw",
                inputError: {
                fontSize: "1vw",
                    icon: {
                        width: "1.05vw",
                        height: "1.05vw",
                        marginBottom: "0.80vw"
                    }
                },
            },            
            inputError: {
                fontSize: "1vw",
                border: "1px solid red",
                icon: {
                    width: "1.05vw",
                    height: "1.05vw"
                }
            },
            groupIcon: {
                icon: {
                    width: "0.88vw",
                    height: "0.98vw"
                },
                arrow: {
                    width: "0.68vw",
                    height: "0.98vw"
                }
            },
            addNewQuestionWrapper: {
                marginTop: "2.08vw",
                paddingLeft: "1.56vw",
                paddingRight: "1.56vw",    
                fontSize: "0.93vw",
                width: "43.95vw"
            },
            frequenltyQuestionButton: {
                fontSize: "0.83vw",
                width: "14.2vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                marginRight: "1.25vw",
                marginLeft: "7.55vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            addNewQuestionButton: {
                fontSize: "0.83vw",
                width: "13.59vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            singleAddNewQuestionButton: {
                fontSize: "0.83vw",
                width: "13.59vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            selectedQuetionsDeleteButton: {
                width: "auto",
                fontSize: "0.83vw",
                height: "2.60vw",
                borderRadius: "0.41vw",
                border: "0.10vw solid" + Color.Linen,
                marginBottom: "0vw"
            },
            singleButton: {
                marginTop: "1.56vw",
                marginLeft: "0.83vw"
            },
            plusIcon: {
                width: "0.78vw",
                height: "0.68vw",
                marginLeft: "0.52vw"
            },
            addNewquestion: {
                width: "43.95vw",
                border: "0.156vw solid" + Color.Gainsboro,
                marginTop: "1.82vw",
                padding: "1.04vw 0.83vw 1.56vw 0.83vw",
                borderRadius: "0.52vw"
            },
            qusetionTittle: {
                fontFamily: Font.Poppins,
                fontWeight: "bold" as "bold",
                color: Color.DeepAsh,
                fontSize: "0.93vw"     
            },
            checkBoxGroup: {
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center"
            },                        
            selector: {
                mainWrapper: {
                    width: "13.54vw",
                    marginTop: "0.52vw"
                },
                label: {
                    fontWeight: "200"
                },
                inputWrapper: {                    
                    border: "0.10vw solid" + Color.SharpAsh,
                    height: "3.64vw",
                    marginTop: "0.15vw"               
                },
                input: {
                    width: "9.00vw",
                    marginLeft: "1.4vw"
                },
                icon: {
                    width: "0.98vw",
                    height: "0.88vw"
                },
                answer: {
                    mainWrapper: {
                        width: "20.72vw"
                    },
                    inputWrapper: {
                        marginTop: "0.52vw",                        
                        border: "0.10vw solid" + Color.SharpAsh
                    },
                    dropdownWrapper: {
                        height: "6.20vw"
                    }
                }
            },
            label: {                
                fontSize: "0.93vw",                                
                marginLeft: "0.52vw"
            },
            questionLabel: {                
                fontSize: "0.93vw",                                
                marginLeft: "0.52vw"
            },
            answerWrapper: {
                marginTop: "1.04vw"
            },                                    
            addSingleChoiceAnswer: {
                display: "flex",
                flexDirection: "row" as "row"
            },                                    
            buttonWrapper: {
                fontSize: "0.72vw",
                marginTop: "1.56vw",
                group: {
                    display: "flex",
                    flexDirection: "row" as "row"                    
                },
                topRow: {
                    order: 1    
                },
                bottomRow: {                                        
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.10vw solid" + Color.DeepBlack, 
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.41vw"
                },
                submit: {
                    width: "10.93vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                update: {
                    width: "10.93vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                delete: {
                    width: "6.35vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.41vw",
                    border: "0.10vw solid" + Color.Linen,
                    marginLeft: "17.81vw",
                    marginBottom: "0vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            answersLabelWrapper: {                
                fontSize: "0.93vw",
                fontWeight: "500",                
                display: "flex",
                flexDirection: "row" as "row",                
                width: "15.88vw",
                paddingRight: "1.2vw",
                marginBottom: "1.04vw"
            },
            answerAndScoreWrapper: {                
                fontSize: "0.83vw",                                                                                
                marginBottom: "0.31vw",
                answer: {
                    maxWidth: "13vw"                                                                                  
                }
            },
            textWithIcon: {                                
                fontSize: "0.83vw"                                    
            },
            deleteIcon: {
                width: "0.78vw",
                height: "0.78vw",
                marginLeft: "1.1vw"               
            },
            labelWithIcon: {                                
                paddingRight: "1vw"
            },
            tittleWithIcon: {                
                paddingRight: "1vw",
                marginLeft: "0.52vw"
            },
            KnockoutAddButton: {
                width: "7.91vw",
                height: "1.82vw",
                fontSize: "0.72vw",                
                borderRadius: "0.36vw",
                marginLeft: "16.61vw",
                marginTop: "0.52vw"
            },                        
            knockoutAnswersWrapper: {
                width: "15.88vw",
                marginTop: "0vw"
            },                                    
            singleAnswerWrapper: {
                marginTop: "0.52",
                width: "24.53vw",
                height: "3.64vw",
                borderRadius: "0.52vw",
                paddingLeft: "1.56vw"
            },
            singleAnswer: {
                fontSize: "0.93vw",
                width: "15.88vw",
                fontWeight: "200",
                border: "none"
            },
            buttonsWrapper: {
                flexwrap: "",
                fontSize: "0.83vw",
                marginBottom: "0vw",
                marginTop: "0vw",
                back: {
                    fontSize: "0.83vw",
                    position: "none" as "none",
                    top: "0",
                    left: "0",
                    border: "0.20vw solid" + Color.SharpAsh,                    
                    width: "5.62vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",                    
                    marginLeft: "0.52vw"    
                },
                next: {
                    fontSize: "0.83vw",                    
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",                    
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "25.35vw"    
                },
                add: {                    
                    width: "5.93vw",
                    height: "1.82vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw",
                    fontSize: "0.83vw"
                },
                ok: {
                    fontSize: "0.93vw",                    
                    width: "5.93vw",
                    height: "2.30vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.28vw",
                    marginLeft: "0vw"  
                },
                save: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "31.15vw",
                    marginTop: "-1.5vw"      
                }
            },
            popUpButtonWrapper: {
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                paddingRight: "1.52vw",
                boxSizing: "border-box" as "border-box"
            },
            questions: {
                width: "43.95vw",
                border: "0.156vw solid" + Color.Gainsboro,
                marginBottom: "1.82vw",                
                padding: "1.04vw 0.83vw 1.56vw 0.83vw",
                borderRadius: "0.52vw"
            },
            insideQuestion: {
                display: "flex",
                flexDirection: "row" as "row",
                paddingLeft: "1.04vw",
                marginTop: "0.83vw"
            },
            questionType: {                
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                width: "4.00vw"
            },
            menuIcon: {
                width: "0.88vw",
                height: "0.62vw",                
                marginLeft: "1.51vw",
                marginTop: "0vw"
            },
            iconGroup: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "center"
            },
            checkBoxWrapper: {
                marginTop: "1.56vw",
                marginBottom: "1.00vw",
                marginLeft: "1.00vw"
            },
            checkBoxText: {
                fontSize: "0.93vw",
            },
            questionTextWrapper: {
                display: "flex",
                flexDirection: "row" as "row",                
                borderLeft: "0.10vw solid" + Color.Gainsboro,
                width: "36.71vw",
                paddingLeft: "1.04vw",
                paddingTop: "0",
                margin: "0 1.04vw 0 1.04vw",                
                fontSize: "0.93vw",
                color: Color.DeepAsh
            },
            questionAnswerWrapper: {
                paddingLeft: "1.04vw",
                marginLeft: "1.04vw",
                borderTop: "",
                borderLeft: "0.10vw solid" + Color.Gainsboro,
                fontSize: "0.93vw",
                marginTop: "0vw",
                paddingTop: "0vw"                       
            },
            answers: {
                minWidth: "7.5vw",                
                marginBottom: "0.31vw",
                fontSize: "0.83vw",
                score: {
                    marginLeft: "0.78vw"
                }
            },
            line: {
                border: "0.052vw solid" + Color.Gainsboro,
                width: "42.29vw",                
                marginTop: "1.56vw",
                marginLeft: "0.83vw",
                marginBottom: "2.08vw"
            },                       
            questionPopup:{
                container: {                    
                    width: "52.99vw",
                    height: "43.85vw",                    
                    borderRadius: "0.52vw",
                    padding: "0.83vw",
                    paddingTop: "0"   
                },
                closeButton: {                    
                    width: "0.94vw",
                    height: "0.94vw",
                    top: "0.61vw",
                    right: "0.41vw"
                }
            },
            questionListWrapper: {
                height: "35.00vw",  
                overflowY: "scroll"
            },
            popUpForm: {
                margin: "0.52vw"                
            },
            searchBar: {               
                width: "100%",
                marginTop: "1.5vw",
                marginBottom: "1vw",
                paddingLeft: "1.52vw",
                paddingTop: "0.58vw",
                paddingBottom: "0.58vw",
                fontSize: "1.04vw",
                backgroundColor: Color.Cultured,
                borderRadius: "0.52vw"                
            },
            popUpQuestionWrapper: {                                               
                border: "0.052vw solid" + Color.Ash,
                padding: "0.78vw",
                marginBottom: "0.78vw",
                fontSize: "1.04vw"
            },
            questionAndAnswer: {                
                fontSize: "0.93vw"
            },
            questionTypeAndButton: {
                display: "flex",
                fontSize: "0.93vw"
            },
            sampleAnswers: {
                marginTop: "0.78vw",
                marginLeft: "0.78vw"
            },
            deleteWarningDialog: {
                container: {
                    width: "22.00vw",
                    height: "13.00vw",
                    borderRadius: "0.52vw",
                    padding: "2vw 2vw"
                }
            },
            smsServiceDialog: {
                container: {
                    width: "29.00vw",
                    height: "6.00vw",
                    borderRadius: "0.52vw",
                    padding: "2.5vw 3vw 2vw 3vw"
                }
            },
            defaultQuestionDialog: {
                container: {
                    width: "29.00vw",
                    height: "5.00vw",
                    borderRadius: "0.52vw",
                    padding: "2.5vw 3vw 1vw 3vw"
                }
            },
            serviceMessageText: {
                fontSize: "1.56vw",                
                marginBottom: "1.51vw"
            },
            deleteDialogTitle: {
                fontSize: "1.56vw",                
                marginBottom: "1.51vw"
            },
            deleteButton: {
                width: "10.15vw",
                height: "2.604vw",
                fontSize: "1.041vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue                    
                },
                red: {
                    marginRight: "0.625vw"                    
                }
            }
        },
        replyMail: {
            mainWrapper: {
                marginLeft: "-0.9vw",
                marginRight: "0vw"
            },
            subTittleWrapper: {
                height: "3.64vw",
                marginTop: "0.36vw"
            },
            subTittle: {
                fontSize: "1.04vw",
                marginLeft: "1.35vw",
                color: Color.LightBlack
            },
            toggleButton: {
                switch: {
                    width: "3.35vw",
                    height: "1.40vw"
                },
                switchCircle: {
                    width: "1.35vw",
                    height: "1.35vw"
                }
            },
            selector: {
                inputWrapper: {
                    marginTop: "0.52vw"               
                }
            },
            skipButtonWrapper: {
                paddingLeft: "1.56vw",
                paddingRight: "1.30vw",
                border: "0.10vw solid" + Color.LightGray,
                width: "10.98vw",
                borderRadius: "0.52vw",
                height: "3.64vw",
                fontSize: "0.93vw"                
            },
            emailWrapper: {
                width: "43.95vw",
                border: "0.15vw solid" + Color.Gainsboro,
                borderRadius: "0.52vw",
                marginTop: "0.31vw",
                padding: "1.04vw 0.88vw 1.30vw 0.83vw"
            },
            emailHeader: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                marginLeft: " 0.52vw"
            },
            textInput: {
                fontSize: "3.86vw",
                marginTop: "0.52vw",
                inputError: {
                    icon: {
                        marginBottom: "1vw"
                    }
                }
            },
            dropup: {
                width: "0.88vw",
                height: "0.98vw"
            },
            menuIcon: {
                width: "0.83vw",
                height: "0.62vw",
                marginLeft: "1.56vw"
            },
            groupWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                justifyContent: "space-between"
            },
            gropuInputWrapper: {
                width: "20.67vw",
                marginTop: "1.04vw"
            },
            inputWrapper: {
                marginTop: "1.04vw"
            },
            emailTitle: {                
                fontSize: "0.93vw",
                marginLeft: "0.52vw",
                marginTop: "1.04vw"
            },
            coverLetterEditor: {
                minHeight: "22.76vw",
                width: "42.00vw",
                marginTop: "0.52vw",
                borderRadius: "0.65vw",
                iconWrapper: {
                    borderRadius: "1.0vw 1.0vw 0vw 0vw"
                }
            },
            notifycation: {
                fontSize: "0.93vw",
                color: Color.SharpAsh
            },
            label: {
                fontSize: "0.93vw",
                marginLeft: "0.52vw"
            },
            emailList: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                border: "0.15vw solid" + Color.Gainsboro,
                width: "43.95vw",
                borderRadius: "0.52vw",
                height: "3.38vw",
                marginTop: "1.04vw",
                marginBottom: "1.04vw",
                paddingRight: "1.35vw",
                paddingLeft: "1.35vw"
            },
            editIcon: {
                width: "0.93vw",
                height: "0.93vw"
            },
            singleAddNewQuestionButton: {
                fontSize: "0.83vw",
                width: "13.59vw",
                height: "2.60vw" ,
                borderRadius: "0.52vw",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            plusIcon: {
                width: "0.78vw",
                height: "0.68vw",
                marginLeft: "0.52vw"
            },
            buttonWrapper: {
                fontSize: "0.72vw",
                marginTop: "1.56vw",
                group: {
                    display: "flex",
                    flexDirection: "row" as "row",
                    alignItems: "center"
                },
                topRow: {
                    order: 1    
                },
                bottomRow: {
                    marginLeft: "0.83vw"    
                },
                saveDraft: {
                    border: "0.10vw solid" + Color.DeepBlack, 
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.41vw"
                },
                submit: {
                    width: "10.93vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                update: {
                    width: "10.93vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.36vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
                },
                delete: {
                    width: "6.35vw",
                    fontSize: "0.72vw",
                    height: "1.82vw",
                    borderRadius: "0.41vw",
                    border: "0.10vw solid" + Color.Linen,
                    marginLeft: "17.81vw",
                    marginBottom: "0vw"
                },
                discard: {
                    border: "0.20vw solid" + Color.DeepBlack,
                    width: "6.35vw",
                    height: "1.82vw",
                    fontSize: "0.72vw",
                    borderRadius: "0.52vw",
                    fontWeight: "bold" as "bold",
                    marginRight: "17.18vw"
                }
            },
            singleButton: {
                marginTop: "2.08vw",
                marginLeft: "0.83vw"
            },
            line: {
                width: "42.29vw",
                marginLeft: "0.83vw",
                marginTop: "1.56vw",
                marginBottom: "2.08vw",
                border: "1px solid" + Color.Gainsboro
            },
            buttonsWrapper: {
                flexwrap: "",
                fontSize: "0.83vw",
                marginBottom: "0vw",
                marginTop: "0vw",
                back:{
                    fontSize: "0.83vw",
                    position: "none" as "none",
                    top: "0",
                    left: "0",
                    border: "0.20vw solid" + Color.SharpAsh,
                    width: "5.62vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    marginLeft: "1.04vw"    
                },
                next: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "25.35vw"    
                },
                add: {
                    width: "5.93vw",
                    height: "1.82vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.78vw",
                    fontSize: "0.83vw"
                },
                ok: {
                    fontSize: "0.93vw",
                    width: "5.93vw",
                    height: "2.30vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginTop: "0.28vw",
                    marginLeft: "42.80vw"
                },
                save: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "31.15vw",
                    marginTop: "-1.5vw"      
                }
            },
            deleteWarningDialog: {
                container: {
                    width: "22.00vw",
                    height: "13.00vw",
                    borderRadius: "0.52vw",
                    padding: "2vw 2vw"
                }
            },
            deleteDialogTitle: {
                fontSize: "1.56vw",
                marginBottom: "1.51vw"
            },
            deleteButton: {
                width: "10.15vw",
                height: "2.604vw",
                fontSize: "1.041vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue                    
                },
                red: {
                    marginRight: "0.625vw",
                    backgroundColor: Color.Linen
                }
            }
        },
        readyToSubmit: {
            mainWrapper: {
                display: "flex",
                flexDirection: "column",
                width: "43.0vw",
                marginLeft: "8.02vw"
            },
            subTopic : {
                marginTop: "1.56vw",
                fontSize: "1.04vw",
                fontWeight: "bold" as "bold",
                marginLeft: "1.00vw",
                color: Color.LightBlack
            },
            tabsWrapper: {
                height: "2.34vw",
                marginTop: "2.60vw",
                marginLeft: "-2.29vw",
                paddingLeft: "2.29vw",
                width: "46.00vw",
                borderBottom: "0.206vw solid" + Color.DeepBlack
            },
            tabs: {
                marginTop: "0vw",
                marginLeft: "0vw",
                height: "2.34vw",
                width: "26.04vw",
                borderRadius: "0.52vw 0.52vw 0 0"                
            },
            tab: {
                height: "2.34vw",
                fontSize: "0.93vw",
                borderRadius: "0.52vw 0.52vw 0 0",
                padding: "0.67vw 1.60vw 0.67vw 1.56vw"
            },
            line: {
                width: "42.29vw",
                border: "0.052vw solid" + Color.Gainsboro,
                marginBottom: "2.08vw",
                marginLeft: "0vw",
                marginTop: "1vw"
            },
            buttonsWrapper: {
                fontSize: "0.83vw",
                marginBottom: "0vw",
                marginTop: "0vw",
                width: "43.12vw",
                marginLeft: "0vw",
                back:{
                    fontSize: "0.83vw",
                    position: "none" as "none",
                    top: "0",
                    left: "0",
                    border: "0.20vw solid" + Color.SharpAsh,
                    width: "5.62vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    marginLeft: "1.35vw"    
                },
                next: {
                    fontSize: "0.83vw",
                    width: "10.93vw",
                    height: "2.60vw",
                    borderRadius: "0.52vw",
                    boxShadow: "0.26vw 0.26vw 2.60vw #00000027",
                    marginLeft: "23.35vw"    
                }
            },
            jobSubmisionDialog: {
                zIndex: "11",
                container: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "39.58vw",
                    height: "15.00vw",
                    borderRadius: "0.52vw",
                    padding: "2vw 2vw",
                    overFlow: "visible"
                }
            },
            deleteDialogTitle: {
                marginBottom: "0.625vw",
                textAlign: "center",
                fontSize: "1.56vw",
                marginTop: "0.52vw"
            },
            popupText: {
                fontSize: "0.83vw",
                marginTop: "0vw"
            },
            jobViewButton: {
                width: "15.10vw",
                height: "2.604vw",
                fontSize: "0.83vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                marginTop: "0vw",
                marginBottom: "0vw",
            },
            tickMark: {
                width: "10.36vw",
                height: "10.36vw",
                marginTop: "-4.50vw",
                marginLeft: "0vw"
            }
        },
        summaryOfCompletion: {
            fullWrapper: {
                marginLeft: "7.18vw",
                marginTop: "1.56vw",
                width: "19.27vw",
                height: "auto",
                border: "",
                backgroundColor: "",
                borderRadius: ""
            },
            tittle: {
                fontSize: "1.04vw",
                fontWeight: "bold" as "bold",
                marginLeft: "1.04vw",
                marginTop: "",
                color: Color.LightBlack
            },
            submitionWrapper: {
                backgroundColor: Color.Blue,
                borderRadius: "1.04vw",
                paddingBottom: "2.29vw",
                editStage: {
                    backgroundColor: Color.DeepBlack,
                    borderRadius: "1.04vw",
                    paddingBottom: "2.29vw"
                }
            },
            mainWrapper: {
                display: "",
                flexDirection: "",
                boxSizing: "border-box" as "border-box",
                width: "19.27vw",
                marginLeft: "",
                backgroundColor: Color.LightAsh,
                marginTop: "1.56vw",
                padding: "2.08vw",
                borderRadius: "1.04vw"
            },
            infoWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginBottom: "0.52vw",
                marginTop: ""
            },
            infoLeftWrapper: { },
            infoRightWrapper: { },
            logoWrapperBag: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                width: "3.07vw",
                height: "3.07vw",
                backgroundColor: Color.Blue,
                borderRadius: "0.52vw",
                complete: {
                    backgroundColor: Color.DeepBlack
                }
            },
            logoWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                width: "3.07vw",
                height: "3.07vw",
                backgroundColor: Color.Gainsboro,
                borderRadius: "0.52vw",
                current: {
                    backgroundColor: Color.Blue
                },
                complete: {
                    backgroundColor: Color.DeepBlack
                },
                finalStage: {
                    backgroundColor: Color.LightBlue
                }
            },
            logoBag: {
                width: "1.12vw",
                height: "1.07vw",
                semiLine: {
                    borderTop: "",
                    borderLeft: "0.20vw dashed" + Color.LightSilver,
                    height: "3.38vw",
                    width: "",
                    marginTop: "0.72vw",
                    marginLeft: "1.53vw",
                    marginRight: "",
                    complete: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Blue
                    }
                }
            },
            logoQuestionMark: {
                width: "0.84vw",
                height: "1.22vw",
                semiLine: {
                    borderTop: "",
                    borderLeft: "0.20vw dashed" + Color.LightSilver,
                    height: "1.82vw",
                    width: "",
                    marginTop: "0.72vw",
                    marginLeft: "1.53vw",
                    marginRight: "",
                    complete: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Blue
                    }
                }
            },
            logoMail: {
                width: "1.28vw",
                height: "0.94vw",
                fill: Color.White,
                semiLine: {
                    borderTop: "",
                    borderLeft: "0.20vw dashed" + Color.LightSilver,
                    height: "0.75vw",
                    width: "",
                    marginTop: "0.72vw",
                    marginLeft: "1.53vw",
                    marginRight: "",
                    complete: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Black
                    },
                    editStage: {
                        borderTop: "",
                        borderLeft: "0.20vw dashed" + Color.Blue
                    }
                }
            },
            logoTumbUp: {
                width: "1.41vw",
                height: "1.35vw"
            },
            checkCircle: {
                width: "0.76vw",
                height: "0.76vw",
                marginLeft: "0.52vw"
            },
            topic: {
                fontSize: "1.04vw",
                fontWeight: "bold" as "bold",
                marginLeft: "1.56vw", 
                marginBottom: " 0.78vw",
                color: Color.LightBlack
            },
            subTopic: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                color: Color.DeepAsh,
                marginLeft: "2.60vw"
            },
            subText: {
                fontFamily: Font.Poppins,
                fontSize: "0.93vw",
                fontWeight: "200",
                color: Color.DeepAsh,
            },
            submitButton: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "15.41vw",
                height: "2.60vw",
                borderRadius: "0.52vw",
                backgroundColor: Color.Green,
                fontWeight: "800",
                fontSize: "0.83vw",
                marginLeft: "1.97vw",
                color: Color.White,
                marginTop: "1.04vw",
                marginBottom: "",
                boxShadow: "0.26vw 0.26vw 2.60vw #00000027"
            },
            viewButton: {
                color: Color.LightBlue,
                backgroundColor: Color.Blue,
                width: "15.20vw",
                height: "2.60vw",
                border: "2px solid" + Color.LightBlue,
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                marginLeft: "1.97vw"
            }   
        }
    }
}